export default {
  general: {
    activate: 'Activer',
    add: 'Ajouter',
    any: 'N\'importe qui',
    avatar: 'Avatars',
    apply: 'Appliquer',
    access_level: 'Niveau d\'accès',
    app_user_settings: 'Paramètres de l\'application et de l\'utilisateur',
    amount: 'Montant',
    all: 'Tous',
    all_tags: 'Toutes les étiquettes',
    assignees: 'Destinataires',
    add_favorite: 'Ajouter un favori',
    add_user: 'Ajouter un utilisateur | Ajouter des utilisateurs',
    add_tag: 'Ajouter une étiquette | Ajouter des étiquettes',
    add_task: 'Ajouter une tâche | Ajouter des tâches',
    add_group: 'Ajouter un groupe | Ajouter des groupes',
    add_phase: 'Ajouter une phase | Ajouter des phases',
    add_account: 'Ajouter un compte | Ajouter un compte',
    add_to_group: 'Ajouter au groupe',
    add_to_projects: 'Ajouter aux projets',
    add_projects_to_users: 'Ajouter tous les utilisateurs sélectionnés aux projets',
    add_users_to_group: 'Ajouter tous les utilisateurs sélectionnés à un groupe',
    add_new: 'Ajouter un nouveau',
    add_time: 'Ajouter du temps',
    archived: 'Archivé | Archivé',
    active: 'Actif',
    archive: 'Archiver',
    archive_clients: 'Archiver les clients',
    assigned_to: 'Attribué à',
    additional_info: 'Informations Complémentaires',
    an_unexpected_error_occurred: 'Une erreur inattendue s\'est produite.',
    billed: 'Ventes',
    billable: 'Facturable',
    billing_status: 'Statut de facturation',
    budget_amount: 'Montant budgétaire',
    bill_by_hour: 'Facturation horaire, avec tarifs facturables',
    bill_a_set_price: 'Facturez un prix fixe, quel que soit le temps suivi',
    billing: 'Facturation',
    bulk_edit: 'Modification groupée {number} {el}',
    budget: 'Budget | Budget',
    billed_expenses: 'Dépenses facturées',
    billed_time: 'Temps facturé',
    close: 'Fermer',
    board: 'Tableau de bord',
    clear_filters: 'Effacer les filtres',
    change_account: 'Changer de compte',
    change: 'Modifier',
    configuration: 'Configuration',
    category: 'Catégorie | Catégories',
    client: 'Client | Clientèle',
    click_to_add: 'Cliquez ici pour en ajouter un nouveau.',
    cost: 'Coût | Frais',
    confirm: 'Confirmer',
    calendar: 'Calendrier',
    creation_date: 'Date de création',
    cancel: 'Annuler',
    color: 'Couleur',
    client_id: 'Numéro client',
    common: 'Commun',
    changes_need_saved: 'Les modifications doivent être enregistrées',
    create: 'Créer',
    create_new_expense_category: 'Créer une nouvelle catégorie de dépenses',
    create_new_project: 'Créer un nouveau projet',
    copy: 'Copie',
    country: 'Pays | Villages',
    current_value_out_of_total_value: '{current_value} le {total_value}',
    currency_per_hour: '{currency}/heure',
    custom: 'Personnalisé',
    copy_phase_from: 'Copier les phases de...',
    change_calendar: 'Changer de calendrier',
    choose_calendar: 'Choisissez le calendrier à partir duquel vous souhaitez importer vos événements',
    deactivate: 'Désactiver',
    deactivated: 'Désactivé',
    deactivated_element: 'Élément désactivé',
    date: 'Date',
    day: 'Jour | 1 jour | {number} jours',
    deleted: 'Supprimé | Éliminé',
    deleted_entry: 'Inscription supprimée',
    deleted_timer: 'Minuterie supprimée',
    deleted_suggestion: 'Suggestion supprimée',
    delete: 'Supprimer',
    delete_confirmation_report: 'Voulez-vous supprimer ce rapport ?',
    dismiss: 'Annuler',
    done: 'Fait',
    dpa: 'Accord de traitement des données',
    drop_image_here: 'Déposez votre image ici',
    drop_your_image: 'Déposez votre image n\'importe où ou cliquez ici pour sélectionner depuis votre appareil',
    delete_element_alert: '| Vous êtes sur le point de supprimer {name} | Vous êtes sur le point de supprimer {number} {element}',
    description: 'Description',
    due_date: 'Expiration',
    e_mail: 'Courriel | E-mail',
    entries_log: 'Liste des enregistrements',
    expense: 'Dépense | Dépenses',
    expense_category: 'Catégorie de dépenses | Catégories de dépenses',
    expense_deletion: 'Annulation des dépenses',
    edit: 'Modifier',
    export: 'Exporter',
    edit_tag_list: 'Modifier le groupe d\'étiquettes',
    entry: 'Inscription | Enregistrements',
    estimate: 'Estimation',
    field_required: 'Champ obligatoire',
    filters: 'Filtres',
    fixed_fee: 'Taux fixe',
    from: 'De',
    get_started: 'Commencer',
    group: 'Groupe | Groupes',
    has_been_archived: 'La phase/le projet lié a été archivé ou vous avez peut-être été supprimé du projet.',
    has_been_updated: '{el} a été mis à jour',
    help_desk: 'Service d\'assistance',
    hourly: 'Toutes les heures',
    hourly_rate: 'Tarif horaire',
    hourly_cost: 'Coût horaire',
    job_title: 'Titre d\'emploi',
    keyboard_shortcuts: 'Touches rapides',
    import_from_ms: 'Importer depuis MS To Do',
    integration: 'Intégration | Intégrations',
    learn_more: 'En savoir plus',
    login: 'Se connecter',
    light: 'Lumière',
    leave_unchanged: 'Laisser inchangé',
    locked_entry: 'Inscription bloquée.',
    lock: 'Bloc',
    list: 'Liste',
    legacy: 'Style ancien',
    labour_costs: 'Coûts de main d\'œuvre',
    last_sync: 'Dernière synchronisation {el}',
    load_more: 'Charger plus',
    loading_integration: 'Chargement de l\'intégration...',
    linked_project_api_only: {
      body: 'Le projet lié est {0} et l\'enregistrement ne peut être modifié que par les administrateurs.',
      api_only: 'API uniquement'
    },
    manager: 'Manager | Responsables',
    member: 'Membre | Membres',
    manage: 'Gérer',
    me: 'Moi',
    menu: 'Menu',
    manage_integration: 'Gérer l\'intégration | Gérer les intégrations',
    my_tasks: 'Mes tâches',
    monetary_budget: 'Budget monétaire',
    multiple_new_projects: 'Plus de nouveaux projets avec modèle',
    new_project: 'Nouveau projet',
    new_team_members: 'Nouveaux membres de l\'équipe',
    no_data: 'Aucune donnée',
    no_budget: 'Pas de budget',
    no_data_for: 'Aucune donnée pour la période en cours',
    none: 'Personne',
    note: 'Remarque | Remarques',
    name: 'Nom | Noms',
    notifications: 'Notifications',
    notes_and_integration_info: 'Notes et informations d\'intégration',
    no_tags: 'Pas d\'étiquette',
    not_assigned: 'Non attribué',
    no_data_available: 'Aucune donnée disponible',
    not_billable: 'Non facturable',
    non_billable: 'Non facturable',
    not_billable_to_client: 'Non facturé à un client',
    no_data_found: 'Aucune donnée trouvée',
    n_a: 'N / A',
    number_member_selected: '{number} membres sélectionnés | Un membre sélectionné | {number} membres sélectionnés',
    number_category_selected: '{number} catégorie sélectionnée | Une catégorie sélectionnée | {number} catégorie sélectionnée',
    number_expense_category_selected: '{number} catégorie de dépenses sélectionnée | Une catégorie de dépenses sélectionnée | {number} catégorie de dépenses sélectionnée',
    number_tag_selected: '{number} étiquette sélectionnée | Une étiquette sélectionnée | {number} libellés sélectionnés',
    number_tag_list_selected: '{number} groupe d\'étiquettes sélectionné | Un groupe d\'étiquettes sélectionné | {number} groupes d\'étiquettes sélectionnés',
    number_todo_selected: '{number} tâche sélectionnée | Une tâche sélectionnée | {number} tâches sélectionnée',
    number_todo_list_selected: '{number} liste de tâches sélectionnées | Une liste de tâches sélectionnée | {number} listes de tâches sélectionnées',
    number_country_selected: '{number} pays sélectionné | Un pays sélectionné | {number} pays sélectionné',
    number_external_selected: '{number} external selected | One external selected| {number} external selected',
    number_user_selected: '{number} utilisateurs sélectionnés | Un utilisateur sélectionné | {number} utilisateurs sélectionnés',
    number_group_selected: '{number} groupe sélectionné | Un groupe sélectionné | {number} groupe sélectionné',
    number_user_updated: '{number} utilisateurs mis à jour | Un utilisateur mis à jour | {number} utilisateurs mis à jour',
    number_client_selected: '{number} clients sélectionnés | Un client sélectionné | {number} clients sélectionnés',
    number_client_unarchived: '{number} clients restaurés | Un client restauré | {number} clients restaurés',
    number_expense_selected: '{number} dépenses sélectionnées | Une dépense sélectionnée | {number} dépenses sélectionnées',
    number_project_selected: '{number} projets sélectionnés | Un projet sélectionné | {number} projets sélectionnés',
    number_project_updated: '{number} projets mis à jour | Un projet actualisé | {number} projets mis à jour',
    number_project_deleted: '{number} projets supprimés | Un projet supprimé | {number} projets supprimés',
    import_data: 'Importer des données',
    import_from: 'Importer depuis',
    insert_password: 'Entrez votre mot de passe',
    integration_info: 'À propos de l\'intégration',
    info: 'Information',
    in_progress: 'En cours',
    or: 'ou',
    please_check_filters: 'Veuillez vérifier vos filtres et réessayer',
    public: 'Publique',
    password: 'Mot de passe',
    phone_number: 'Numéro de téléphone',
    this_should_be_phone_number: 'Ceci devrait être un numéro de téléphone',
    priority: 'Priorité',
    project: 'Projet | Projets',
    project_hourly_rate: 'Taux horaire du projet',
    project_hourly_rate_required_for: 'Le taux horaire du projet est nécessaire pour calculer la valeur monétaire de votre temps et maintenir le budget du projet à jour.',
    phase: 'Phase | Phases',
    phase_category: 'Catégorie de phases | Catégories de phases',
    product: 'Produit',
    pre_select_projects: 'Présélectionner des projets pour les événements importés',
    passwords_do_not_match: 'Les mots de passe ne correspondent pas',
    personal_access_tokens: 'Jetons d\'accès personnels',
    project_with_no_tags: 'Ce projet n\'a pas d\'étiquette.',
    progress: 'Progrès',
    project_budget: 'Budget du projet',
    project_fee: 'Commande de projet',
    report: 'Rapport | Rapports',
    required: 'Nécessaire',
    read_article: 'Lire l\'article',
    required_at_least_one_tag: 'Exiger au moins une étiquette pour chaque enregistrement',
    reload: 'Recharger',
    repeat_password: 'Répéter le mot de passe',
    remove: 'Retirer',
    remove_favorite: 'Supprimer le favori',
    register_time: 'Enregistrez l\'heure',
    report_delete_advertisment: 'Après confirmation, tout automatisme associé à ce rapport sera supprimé',
    report_delete_error: 'Un problème est survenu lors de la suppression de ce rapport.',
    required_field: 'Champ obligatoire',
    revenue: 'Revenu',
    timesheet: 'Feuille de temps | Feuilles de temps',
    time_spent: 'Temps passé',
    update_password: 'Mettre à jour le mot de passe',
    updating_your_password: 'Mise à jour de votre mot de passe...',
    un_archive: 'Restaurer',
    unit_price: 'Prix ​​unitaire',
    update: 'Mettre à jour',
    updated: 'Mis à jour | Mis à jour',
    updated_last_project: 'Projet mis à jour',
    user: 'Utilisateur | Utilisateurs',
    user_deactivated: 'Utilisateur désactivé.',
    undo_deletion: 'Annuler la suppression',
    unknown_phase: 'Phase inconnue',
    users_will_not_be_able_track_time: 'Les utilisateurs ne pourront pas étiqueter leurs enregistrements',
    users_will_be_able_to_tag_any_tag: 'Les utilisateurs pourront étiqueter leurs enregistrements avec n\'importe quelle étiquette d\'espace de travail',
    users_will_be_able_to_tag_selected_tag_list: 'Les utilisateurs pourront uniquement étiqueter leurs enregistrements avec les groupes d\'étiquettes sélectionnés',
    unarchived: 'Restauré',
    unbilled_expenses: 'Dépenses non facturées',
    unbilled: 'Non facturé',
    unbilled_time: 'Temps non facturé',
    unbilled_money: 'Argent non facturé',
    unbilled_explain: 'Argent non facturé = main d\'œuvre non facturée + dépenses non facturées + forfait non facturé',
    updated_data: 'Certaines données ont changé depuis le chargement de la dernière page',
    start_timer: 'Démarrer le chronomètre',
    save_entry: 'Enregistrer l\'enregistrement',
    sync_private_appointments: 'Synchroniser les rendez-vous privés',
    set_hourly_rate: 'Fixez votre taux horaire',
    set_hourly_cost: 'Définir le coût horaire',
    set_expense_lock: 'Mettre en place un gel des dépenses',
    set_billing_status: 'Définir votre statut de facturation',
    select_tags: 'Sélectionnez l\'étiquette | Sélectionner des étiquettes',
    select_assignees: 'Sélectionner les destinataires',
    select_status: 'Sélectionnez l\'état',
    select_priority: 'Sélectionnez la priorité',
    start_date: 'Date de début',
    sla: 'SLA',
    save: 'Sauvegarder',
    show: 'Montrer',
    sort_by: 'Trier par',
    full_name: 'Nom et prénom',
    search_within_expense_categories: 'Rechercher dans les catégories de dépenses',
    start_tracking_time: 'Commencer à suivre le temps',
    select_all: 'Tout sélectionner',
    select_calendar: 'Sélectionnez un calendrier',
    set_access_level: 'Définir le niveau d\'accès',
    set_access_level_user: 'Définir le niveau d\'accès pour tous les utilisateurs sélectionnés',
    seconds: 'Secondes',
    team: 'Équipe | Équipes',
    tag: 'Étiquette | Étiquettes',
    to: 'À',
    total: 'Total | Totaux',
    time: 'Temps',
    timer: 'Minuterie | Minuteries',
    tag_list: 'Groupes d\'étiquettes | Groupes d\'étiquettes',
    tag_lists: 'Groupes d\'étiquettes',
    todo_list: 'Liste des tâches',
    task: 'Tâche | Tâches',
    task_list: 'Liste des tâches',
    time_worked: 'Temps travaillé',
    total_time: 'Durée totale',
    total_cost: 'Coût total',
    total_revenues: 'Revenu total',
    total_billed: 'Chiffre d\'affaires total',
    terms_conditions: 'Conditions générales',
    team_member: 'Membre de l\'équipe | Membres de l\'équipe',
    timer_started: 'Le chronomètre a démarré.',
    timer_saved: 'Minuterie enregistrée.',
    timer_paused: 'Le minuteur a été mis en pause',
    time_budget: 'Budget-temps',
    time_tracked: 'Temps surveillé',
    timezone: 'Décalage horaire',
    timeframe: 'Laps de temps',
    table_configuration: 'Configuration des tableaux',
    tag_lists_and_tags: 'Groupes d\'étiquettes et étiquettes',
    time_and_material: 'Temps et matériel',
    url: 'URL',
    optional: 'facultatif',
    optional_notes: 'Notes facultatives pour référence',
    overview: 'Aperçu',
    other: 'Plus | Autres',
    you_are_about_to_add_element: 'Vous êtes sur le point d\'ajouter <b>{number} {first_el} à {article} {second_el}</b>.<br/> Cette action nécessite une confirmation',
    working_time: 'Horaires de travail',
    without_element: 'Sans {el}',
    watch_the_video: 'Regardez la vidéo',
    workspace_settings: 'Paramètres du compte',
    why_this_field_required: 'Pourquoi ce champ est-il obligatoire ?',
    webhooks: 'Webhooks',
    weekly: 'Hebdomadaire',
    biweekly: 'Bimensuel',
    monthly: 'Mensuel',
    entry_locked_by_approval: 'Cette entrée a déjà été approuvée et ne peut donc pas être modifiée.',
    all_entries_older: 'Toutes les inscriptions antérieures au {0} sont verrouillées et ne peuvent être modifiées que par les administrateurs.',
    all_dates_older: 'Toutes les dates antérieures au {0} sont verrouillées et ne peuvent pas être utilisées pour créer de nouvelles entrées / minuteries.',
    date_locked_by_approval: 'Cette date fait partie d\'une période approuvée et ne peut pas être utilisée pour créer de nouvelles entrées/minuteurs.',
    create_webhook: 'Créer un Webhook',
    edit_webhook: 'Modifier le Webhook',
    webhook_url: 'URL du Webhook',
    webhook_secret: 'Secret du Webhook',
    events: 'Événements',
    webhook_logs: 'Journaux des Webhooks',
    event: 'Événement',
    payload: 'Charge utile',
    status: 'État',
    delivered_at: 'Livré à',
    attempts: 'Tentatives',
    saved_successfully: 'Enregistré avec succès',
    phases_updated: 'Phases mises à jour avec succès'
  },
  access_levels: {
    admin: 'Admin | Administrateurs',
    owner: 'Propriétaire | Propriétaires',
    member: 'Membre | Membres',
    pm: 'PM | PMs',
    gm: 'GM | GMs',
    direct_manager: 'Manager direct',
    all_managers: 'Tous les managers'
  },
  priorities: {
    low: 'Faible',
    medium: 'Moyenne',
    high: 'Haut'
  },
  timeframe: {
    all_time: 'Toujours',
    custom: 'Personnalisé',
    hours: 'Heures',
    never: 'Jamais',
    day: 'Jour | Jours',
    daily: 'quotidien',
    week: 'Semaine',
    weekly: 'hebdomadaire',
    month: 'Mois',
    monthly: 'mensuel',
    day_of_week: 'Jour de la semaine',
    day_of_month: 'Jour du mois',
    invalid_day: 'Jour invalide',
    weekends: 'Fin de semaine',
    time: 'Temps',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    this_week: 'Cette semaine',
    this_month: 'Ce mois-ci',
    this_year: 'Cette année',
    last_week: 'La semaine dernière',
    last_month: 'Mois dernier',
    last_7_days: '7 derniers jours',
    last_15_days: '15 derniers jours',
    last_30_days: '30 derniers jours',
    last_3_months: '3 derniers mois',
    last_6_months: '6 derniers mois',
    last_12_months: '12 derniers mois'
  },
  days: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche'
  },
  entries: {
    updated_entry: 'Inscription mise à jour',
    entry_copied: 'Enregistrement copié.',
    to_filter_phases_select_project: 'Pour filtrer par phases, vous devez sélectionner un seul projet'
  },
  timer: {
    pause: 'Casser',
    start: 'Commencer',
    save_as_an_entry: 'Enregistrer comme enregistrement',
    updated_last_timer: 'Minuterie mise à jour',
    timer_paused: 'Le minuteur a été mis en pause',
    timer_started: 'Le chronomètre a démarré',
    timer_saved_as_entry: 'Minuterie enregistrée comme enregistrement.'
  },
  suggestion: {
    accept: 'Accepter',
    ignore: 'Ignorer',
    suggestion_accepted: 'Suggestion acceptée et enregistrée comme enregistrement.',
    suggestion: 'Pas de suggestions | 1 suggestions | {el} suggestions'
  },
  tasks: {
    assigned_to_me: 'M\'a été attribué'
  },
  roles: {
    accountant: 'Comptable',
    business_development_professional: 'Professionnel du développement des affaires',
    business_owner_or_founder: 'Entrepreneur ou fondateur',
    customer_service_representative: 'Représentant du service à la clientèle',
    data_science_engineer: 'Ingénieur en science des données',
    designer: 'designer',
    devOps_engineer: 'Ingénieur DevOps',
    facilities_manager: 'Gestionnaire d\'infrastructures',
    financial_advisor: 'Conseiller financier',
    fitness_coach: 'Instructeur de conditionnement physique',
    group_manager: 'Responsable de groupe',
    gm: 'Responsable de groupe',
    health_professional: 'Professionnel de la santé',
    human_resources_professional: 'Professionnel des ressources humaines',
    information_technology_rofessional: 'Professionnel de l\'informatique',
    legal_professional: 'Professionnel du droit',
    marketer: 'Vendeur',
    mechanical_engineer: 'Ingénieur mécanique',
    office_manager: 'Chef de bureau',
    operations_professional: 'Professionnel des opérations',
    pm: 'MP',
    personal_assistant: 'Assistant personnel',
    president_or_ceo: 'Président ou PDG',
    product_manager: 'Chef de produit',
    project_manager: 'Chef de projet',
    property_manager: 'Gestionnaire immobilier',
    public_relations_professional: 'Professionnel des relations publiques',
    real_estate_agent: 'Agent immobilier',
    recruiter: 'Recruteur',
    salesperson: 'Vendeur',
    school_administrator: 'Administrateur d\'école',
    software_engineer: 'Ingénieur logiciel',
    student: 'Étudiant',
    teacher_or_professor: 'Enseignant ou professeur',
    web_engineer: 'Ingénieur Web',
    writer_or_editor: 'Écrivain ou éditeur',
    member: 'Membre | Membres',
    description: {
      admin: 'Administrateur',
      owner: 'Propriétaire',
      member: 'Membre | Membres'
    }
  },
  industries: {
    marketing_communication: 'Communication marketing',
    software_development: 'Développement de logiciels',
    media_entertainment: 'Médias et divertissement',
    business_consulting: 'Conseil aux entreprises',
    real_estate: 'Immobilier',
    education: 'Éducation scolaire',
    trasportation: 'Transport',
    law: 'Loi',
    health: 'Santé'
  },
  integrations: {
    asana: 'Asanas',
    basecamp_2: 'Camp de base 2',
    basecamp_3: 'Camp de base 3',
    google_calendar: 'Google Calendar',
    teams: 'Équipes',
    outlook: 'Outlook',
    outlook_calendar: 'Calendrier Outlook',
    outlook_office_365: 'Calendrier Outlook/Office 365',
    planner: 'Microsoft Planner',
    project: 'Projet',
    power_bi: 'PowerBi',
    azure_devOps: 'Azure DevOps',
    to_do: 'Faire',
    gitHub: 'GitHub',
    workspace: 'Espace de travail',
    calendar: 'Calendrier',
    jira: 'Jira',
    microsoft: 'Microsoft',
    ms_to_do: 'MS To Do',
    microsoft_to_do: 'Microsoft To Do',
    microsoft_teams_calls: 'Équipes Microsoft',
    ms_planner: 'MS Planner',
    link: 'Connexion',
    microsoft_planner: 'Microsoft Planner',
    google_workspace: 'Espace de travail Google',
    suggest_an_integration: 'Proposer une intégration',
    your_daily_activity: 'Votre activité quotidienne'
  },
  phases: {
    social_media: 'Réseaux sociaux',
    blog: 'Blogues',
    analytics: 'Analytique',
    bugfix: 'Résolution du problème',
    feature: 'Fonctionnalité',
    design: 'Projet',
    testing: 'Test',
    meeting: 'Réunion',
    calls: 'Appels',
    accounting: 'Comptabilité',
    development: 'Développement',
    support: 'Soutien'
  },
  files: {
    xlsx: 'XLSX',
    csv: 'CSV',
    pdf: 'PDF'
  },
  validation: {
    validData: 'Doit contenir une date valide',
    amount_grater_than: 'Le montant doit être supérieur ou égal à 0',
    amount_less_than: 'Le montant doit être inférieur au montant non facturé',
    name_required: 'Le nom est obligatoire',
    give_report_a_name: 'Donnez un nom au rapport pour l\'enregistrer',
    task_name_required: 'Le nom de le tâche est obligatoire',
    min_length: 'Doit comporter au moins {length} caractères'
  },
  tag_lists: {
    marketing: 'Commercialisation',
    seo: 'Référencement',
    adv: 'PUBLICITÉ',
    social: 'Sociale',
    finance: 'Finances',
    budgeting: 'Budgétisation',
    investing: 'Investir',
    design: 'Projet',
    wireframes: 'Filaires',
    ideas: 'Idées',
    it: 'IL',
    bugfix: 'Corrections de bugs',
    dev: 'Développement',
    training: 'Entraînement',
    internal_communication: 'Communication interne',
    meeting: 'Rencontre',
    calls: 'Appels',
    support: 'Soutien',
    complaints: 'Plaintes',
    review: 'Révision',
    issues: 'Problèmes',
    customer_service: 'Assistance client',
    ticketing: 'billetterie',
    chat: 'Chat',
    technical_support: 'Assistance technique',
    hr: 'ressources humaines',
    talent_acquisition: 'Acquisition de talents',
    onboarding: 'Insertion',
    payroll: 'Paie'
  },
  components: {
    licenseNumberDialog: {
      title: 'Gérer les licences',
      licenses: 'Combien de licences souhaitez-vous dans votre espace de travail ?',
      decrease_licenses: 'Si vous avez besoin de moins de licences que celles incluses dans votre forfait actuel, veuillez {contact}.',
      contact: 'contacter l\'assistance',
      amount_due: 'Aujourd\'hui, vous serez facturé {amount} {currency}, pour {licenses} licences jusqu\'à la fin de votre période d\'abonnement.',
      next_renewal: 'Lors de votre prochain renouvellement, votre paiement de {period} sera de {amount} {currency}, pour {licenses} licence.'
    },
    addUserDialog: {
      add_a_new_user: 'Ajouter un nouvel utilisateur',
      email_address: 'Adresse email',
      adding_secondary_user: 'L\'ajout d\'un utilisateur secondaire vous donnera la possibilité de basculer rapidement entre les utilisateurs à partir du menu du profil.',
      user_inactiv: 'Cet utilisateur a été déconnecté pour cause d\'inactivité.{br} Veuillez saisir à nouveau votre mot de passe.',
      already_logged_in: 'L\'utilisateur est déjà connecté.',
      incorect_login: 'Données de connexion incorrectes.'
    },
    appDialog: {
      app: 'Application',
      app_logo: 'Logo de l\'application',
      app_created: 'Application créée.',
      app_saved: 'Application enregistrée.',
      app_name_between: 'Le nom de l’application est obligatoire et doit comporter de 3 à 256 caractères.',
      app_website_url: 'URL du site Web de l\'application',
      client_secret: 'Secret client',
      cancel_uri: 'Effacer l\'URI *',
      developer_name: 'Nom du développeur *',
      developer_name_between: 'Le nom du développeur est obligatoire et doit comporter de 3 à 256 caractères.',
      description_not_more_than: 'La description ne peut pas contenir plus de 512 caractères.',
      max_upload_size: 'Taille maximale de téléchargement 2 M (jpg, jpeg, png, bmp, svg, webp)',
      privacy_policy: 'URL de la politique de confidentialité',
      redirect_uri: 'URI de redirection *',
      redirect_uri_required: 'L’URI de redirection est requis.',
      terms_conditions_url: 'URL des conditions générales',
      will_be_able_to_uploade: 'Vous pourrez télécharger votre avatar après avoir créé l\'application'
    },
    addPhasesDialog: {
      add_phases_to_projects: 'Ajouter des phases aux projets'
    },
    bulkEditExpensesDialog: {
      lock_selected_expenses: 'Bloquer les dépenses sélectionnées',
      unlock_selected_expenses: 'Débloquez les dépenses sélectionnées',
      edit_multiple_expenses: 'Modifier plusieurs dépenses'
    },
    bulkEditProjectsDialog: {
      set_a_client: 'Créer un client',
      edit_multiple_projects: 'Modifier plusieurs projets'
    },
    bulkEditUsersDialog: {
      edit_multiple_users: 'Modifier plusieurs utilisateurs',
      set_manager: 'Assigner un chef'
    },
    clients: {
      search_clients: 'Rechercher parmi les clients',
      active_clients: 'Clients actifs',
      archived_clients: 'Clients archivés',
      advise_archive: 'Vous êtes sur le point d\'archiver un client | Vous êtes sur le point d\'archiver {number} clients',
      advise_project: 'Chaque projet attaché à ce client sera archivé | Tout projet rattaché à ces clients sera archivé',
      new_client: 'Nouveau client',
      number_client_archived: '{number} client archivé | {number} clients archivés.',
      number_client_deleted: '{number} client supprimé | {number} clients supprimés.'
    },
    configurationMenu: {
      option_configurations: 'Configuration des options',
      actions_onfigurations: 'Configuration des actions',
      time: 'TEMPS',
      money: 'ARGENT'
    },
    calendarConfigurationDialog: {
      calendars_could_not_be_fetched: 'Impossible de récupérer les calendriers. Veuillez réessayer après avoir réautorisé votre compte.',
      connected: 'Connecté',
      you_have_linked_integration: 'Vous avez lié votre {name} à votre compte {br}Timeneye',
      it_might_take_minuts: 'L\'affichage de vos {br} événements dans votre tableau de bord peut prendre quelques minutes.',
      link_to_your_user: 'Connectez {name} à votre utilisateur',
      back_to_dashboard: 'Retour au tableau de bord',
      fetching_calendars: 'Récupération des calendriers...'
    },
    createPhaseDialog: {
      error_creating_phase: 'Erreur lors de la phase de création.',
      create_new_phase: 'Créer une nouvelle scène',
      account: 'Comptes | Comptes',
      created_last_phase: 'Phase créée'
    },
    copyPhaseCategoryDialog: {
      from_existing_project: 'À partir d\'un projet existant',
      from_timeneye_preset: 'Depuis le préréglage Timeneye',
      marketing_preset: 'Préréglages marketing',
      developer_preset: 'Préréglages du développeur',
      sales_preset: 'Préréglages de vente',
      customer_service_preset: 'Préréglages du service client',
      select_present_for_phases: 'Sélectionnez un préréglage à partir duquel copier les phases'
    },
    copyPhasesDialog: {
      filter_projects: 'Filtrer les projets',
      copy_phases: 'Copiez les étapes',
      management: 'Gestion'
    },
    clientDialog: {
      you_are_about_to_archive_name: 'Vous êtes sur le point d\'archiver {name}<br> Tous les projets liés à ce client seront archivés',
      archiving_client: 'Archivage clients',
      un_archiving_client: 'Récupération client',
      client_archived: 'Client archivé',
      client_unarchived: 'Client restauré',
      client_name_required: 'Un nom de client est requis',
      create_client: 'Créer un client',
      edit_client: 'Modifier le client',
      created_last_client: 'Client créé',
      deleted_client: 'Client supprimé',
      delete_clients: 'Supprimer des clients',
      updated_last_client: 'Client mis à jour'
    },
    clientArchiveDialog: {
      you_are_about_to_archive: 'Vous êtes sur le point de déposer'
    },
    clientsDeleteDialog: {
      entries_unlinked: {
        all_entries_going_to: 'TOUS les enregistrements enregistrés sur ces clients {0}',
        unlinked_from_it: 'ils en seront déconnectés'
      },
      dont_want_to_lose_client: 'Si vous ne souhaitez pas perdre vos données, nous vous recommandons d\'archiver ce client. | Si vous ne souhaitez pas perdre vos données, nous vous recommandons plutôt d\'archiver ces clients.'
    },
    dashboard: {
      dashboard: 'Tableau de bord',
      another_member_calendar: 'Vous consultez le calendrier d\'un autre membre',
      timezone_alert: 'AVERTISSEMENT : Votre fuseau horaire actuel est différent de celui de vos paramètres, {go_to_profile_settings}',
      go_to_profile_settings: 'veuillez le mettre à jour pour éviter tout problème.',
      go_to_profile_settings_tooltip: 'Aller aux paramètres de profil',
      ignore_timezone_alert: 'Fermer',
      collapse: 'Contracter',
      loading_calendar: 'Chargement des événements du calendrier...',
      loading_calendar_wait: 'Chargement des événements du calendrier. Cela peut prendre un certain temps',
      linked_to_account: 'est lié à ce compte. Cliquez ici pour en savoir plus !',
      personal_budgets: 'Budgets personnels',
      havent_budgets: 'Vous n\'avez pas de budget personnel.',
      havent_project_budgets: 'Vous n\'avez aucun budget alloué à vos projets',
      how_crate_budget: 'Comment créer un budget',
      old_timers: 'Vous avez une minuterie en attente d\'être enregistrée en tant qu\'enregistrement | Vous avez {timers_count} minuteurs en attente d\'être enregistrés en tant qu\'enregistrement',
      insights: 'Connaissances',
      client_recap: 'Résumé client',
      link_ms_todo: 'Connecter MS To Do',
      manage_ms_todo: 'Gérer MS To Do',
      clients_recap: 'Résumé client',
      projects_recap: 'Résumé du projet',
      phase_recap: 'Chat. résumé phase',
      no_element_selected_time: 'Il n\'y a aucun enregistrement sur aucun {element} dans la plage horaire sélectionnée.',
      time_recap: 'Résumé du temps',
      open_recap: 'Ouvrez le résumé pour voir la dernière inscription des membres.',
      no_time_tracked: 'Aucun membre de votre équipe n\'a suivi l\'heure.',
      recap: 'Résumé',
      sort_tasks: 'Trier les tâches',
      add_new_task: 'Ajouter une nouvelle tâche',
      no_matching_filters: 'Aucune tâche correspondant aux filtres',
      link_ms_to_do: 'Connecter MS To Do',
      dont_show_this_anymore: 'Ne le montre plus',
      import_from_ms: 'Importer depuis MS Planner',
      try_to_sync_again: 'Essayez à nouveau de synchroniser',
      dont_show_this: 'Ne le montre pas',
      locked_date: 'Date de blocage',
      not_your_calendar: 'Pas votre calendrier',
      cant_track_time_for_other_members: 'Vous ne pouvez pas enregistrer le temps des autres membres à l\'aide du calendrier, veuillez plutôt utiliser le bouton d\'enregistrement.',
      search_task: 'Rechercher des tâches',
      cannot_edit_other_member_entries: 'Vous ne pouvez pas modifier les enregistrements lorsque vous consultez le calendrier d\'un autre membre.',
      average_mood: 'Humeur moyenne',
      move: 'Relâchez ici pour \\A MOVE \\A ce jour-là',
      copy: 'Libérez ici pour \\A COPY \\A ce jour',
      tag_list_recap: 'Résumé du groupe d\'étiquettes',
      hold_shift: '(maintenez la touche MAJ enfoncée pour copier)',
      link_calendar: 'Connectez le calendrier',
      open_service_link: 'Ouvrez le lien du service dans un nouvel onglet',
      total_time_of_total_working_time: '{total_time} sur {total_working_time}',
      no_suggestion: 'Aucune suggestion',
      refresh: 'Recharger',
      update_bassed_on_teams_call_log: 'Mise à jour basée sur le journal des appels des équipes. (Durée initiale : {0})',
      actual_duration: 'Durée effective',
      timeline: 'Chronologie',
      cards: 'Cartes'
    },
    dialogs: {
      action_not_reversible: 'ATTENTION : Cette action n\'est pas réversible.',
      element_delete: {
        any_element_will_be_deleted: 'Toutes les données liées à ces {element} seront immédiatement supprimées et il sera {not} possible de les restaurer.',
        not: 'Pas'
      },
      disabling_option: 'La désactivation de cette option ne synchronisera pas les futurs rendez-vous privés, mais ne supprimera pas ceux déjà importés.',
      feedback: 'Suggestions',
      hide: 'CACHER',
      last_timer: 'Dernière minuterie',
      manage_phases: 'Gérer les phases',
      no_matching_filters: 'Aucun résultat correspondant pour les filtres actuels',
      phase_name: 'Nom de la phase',
      project_with_no_tags_edit: 'Ce projet n\'a pas d\'étiquette. Modifiez les paramètres du projet pour ajouter des étiquettes.',
      users_invited: 'Utilisateurs invités',
      ok: 'D\'ACCORD',
      select_projects: 'Sélectionnez des projets',
      selected_users: 'Utilisateurs sélectionnés',
      set_expense_category: 'Configurer une catégorie de dépenses',
      workspace_access_level: 'Niveau d\'accès à l\'espace de travail'
    },
    dashboardSettingsDialog: {
      clients_recap: 'Résumé client',
      entity_notes: 'Notes sur l\'entité',
      dont_show_any_module: 'Ne montrer aucun formulaire',
      dashboard_settings_saved: 'Paramètres du tableau de bord enregistrés',
      modules_state: {
        modules: 'Modules :',
        modules_none: '{0} Masqué',
        modules_top_bar: '{0} Barre supérieure',
        modules_bottom_bar: '{0} Barre inférieure',
        modules_left_sidebar: '{0} Barre latérale gauche',
        modules_right_sidebar: '{0} Barre latérale droite'
      },
      projects_recap: 'Résumé du projet',
      phase_categories_recap: 'Résumé des catégories de phases',
      dashboard_configuration: 'Configuration du tableau de bord',
      bottom: 'En conclusion',
      left: 'Gauche',
      right: 'Droite',
      top: 'Supérieur'
    },
    existingDomainDialog: {
      workspace_domain_exist: {
        looks_like_workspace_domain: 'Il semble qu\'un compte avec le domaine {element} existe déjà'
      },
      probably_someone_has_workspace: 'Un membre de votre équipe a probablement déjà créé un compte sur timeneye.',
      please_wait_invitation: 'Attendez un e-mail d\'invitation ou contactez {br} l\'administrateur de votre compte.',
      ok_got_it: 'D\'accord, je l\'ai compris',
      create_workspace: {
        i_want_to: 'Je souhaite continuer et créer un {0}',
        create_workspace: 'nouvel espace de travail'
      },
      new_workspace: 'nouvel espace de travail',
      sure_create_workspace: 'Êtes-vous sûr de vouloir créer un nouveau compte ?',
      keep_in_mind: 'S\'il vous plaît gardez cela à l\'esprit',
      wont_be_able_join_workspace: 'Vous ne pourrez pas participer à d\'autres domaines de travail',
      you_can_be_in_single_workspace: 'Vous pouvez faire partie d\'un seul compte',
      join_workspace_invited: 'Si vous souhaitez rejoindre un <strong>compte existant</strong>, vous devez être <strong>invité</strong>'
    },
    expenseCategoryDialog: {
      this_category_unit_price: 'Cette catégorie a un prix unitaire',
      expense_category_created: 'Catégorie de dépenses créée',
      expense_category_name: 'Nom de la catégorie de dépenses',
      edit_expense_name: 'Modifier {expense_name}',
      unit_name: 'Unité de mesure',
      unit_name_placeholder: 'par exemple km, photocopies'
    },
    expenseDialog: {
      you_are_deleting_expense: 'Vous êtes sur le point de supprimer cette dépense<br/>Cette action nécessite une confirmation',
      expense_created_successfuly: 'Dépense créée avec succès',
      quantity: 'Montant',
      create_new_expense: 'Créer une nouvelle dépense',
      expense_details: 'Détails de la dépense',
      deleted_expense: 'Dépense éliminée',
      edit_expense: 'Modifier une dépense',
      member: 'Membre | Membres',
      updated_last_expenses: 'Dépenses mises à jour'
    },
    entries: {
      revenue: 'Revenu',
      x_more_tags: '+{el} autres libellés',
      hide_filters: 'Masquer les filtres',
      show_filters: 'Afficher les filtres',
      number_entries_selected: '{number} sélectionné.',
      your_activity: 'Votre entreprise',
      advanced_filters: 'Filtres avancés',
      notes_integration_info: 'Notes et informations d\'intégration',
      x_items_selected: '{el} éléments sélectionnés',
      x_time_total: '{el} au total',
      total: 'total',
      billed_status: 'Statut de facturation',
      format: 'Formatage',
      delete_selected_items: 'Supprimer les éléments sélectionnés',
      update_entries: 'Mettre à jour les enregistrements',
      no_data_for_timeframe_filters: 'Aucune donnée pour la plage horaire et les filtres sélectionnés.',
      run_entries_report: 'Exécuter des rapports d\'enregistrement',
      export_selected_entries: 'Exporter les enregistrements sélectionnés',
      export_entries_filters: 'Exporter des enregistrements en fonction des filtres appliqués',
      listed_out_of_total: '{el_number} répertoriés sur {total_el} totaux',
      error_exporting_file: 'Erreur lors de l\'exportation de {el}.',
      error_generating_pdf: 'Une erreur s\'est produite lors de la génération du PDF',
      delete_selected_entries: 'Supprimer les enregistrements sélectionnés',
      user_confirmation_dialog: "\n        Vous \xEAtes sur le point de mettre \xE0 jour <strong>{sanitized_length}</strong> {element}<br />\n        Changements :<br />\n        <ul>\n        <li>{changes_length}</li>\n        </ul>\n      ",
      open_in_a_new_tab: 'Ouvrir dans un nouvel onglet',
      ignore_suggestion: 'Ignorer la suggestion',
      unknown_project: 'Projet inconnu',
      to_file: 'à {file}',
      date_from_to_date_to: 'de {date_from} à {date_to}',
      any_state: 'N\'importe quel état',
      no_changes: 'Aucun changement',
      paused: 'En pause.',
      set_as_billable: 'Définir comme facturable',
      set_as_billed: 'Définir comme revenu',
      set_as_unbilled: 'Définir comme non facturé',
      set_as_not_billable: 'Définir comme non facturable',
      set_owner: 'Définir le propriétaire',
      set_project: 'Mettre en place un projet',
      set_phase: 'Définir la phase',
      set_date: 'Fixer la date',
      set_billed_status: 'Définir votre statut de facturation',
      search: 'Recherche...',
      started: 'Commencé.',
      without_group: 'Sans groupe',
      from_date_to_date: 'de {date_from} à {to_date}',
      entries_out_of_total: '{current_value} répertorié sur {totalEntries}',
      without_client: 'Sans client',
      without_category: 'Non classé',
      without_tag: 'Sans étiquette',
      without_tag_list: 'Sans groupe d\'étiquettes'
    },
    expenseCategories: {
      expense_category_deletion: 'Suppression d\'une catégorie de dépenses',
      category_deleted: 'Catégorie supprimée',
      category_state_archived: 'Catégorie archivée',
      category_state_unarchived: 'Catégorie non archivée',
      category_cant_be_deleted: 'Cette catégorie ne peut être éliminée car il y a des dépenses qui y sont liées',
      curency_unit_price_per_unit_name: '{curency_symbol} {unit_price_first} tous les {unit_name_second}',
      active_categories: 'Catégories actives',
      deactivated_categories: 'Catégories archivées',
      new_expense_category: 'Nouvelle catégorie de dépenses',
      you_are_deleting_expense_category: 'Vous êtes sur le point de supprimer cette catégorie de dépenses<br/><div class="text-body2 q-mt-sm">Cette action n\'est pas réversible. Si vous ne souhaitez pas perdre vos données, nous vous recommandons d\'archiver cette catégorie.</div>'
    },
    expenses: {
      search_within_expenses: 'Rechercher parmi les dépenses',
      set_billing_status_for_all_selected_expenses: 'Définir le statut de facturation pour toutes les dépenses sélectionnées',
      set_expense_category_for_all: 'Définir la catégorie de dépenses pour toutes les dépenses sélectionnées',
      category_cannot_be_changed: 'Vous ne pouvez pas modifier la catégorie des dépenses à prix unitaire fixe.',
      lock_expenses: 'Geler les dépenses',
      unlock_expenses: 'Débloquez les dépenses',
      locked: 'Cette dépense ne peut pas être modifiée',
      locked_by_approval: 'Cette dépense est approuvée et ne peut donc pas être modifiée',
      dont_have_permision: 'Les dépenses approuvées ne peuvent pas être modifiées',
      you_are_about_to_delete_expense: 'Vous êtes sur le point de supprimer {el}.<br/> Cette action nécessite une confirmation',
      this_expense: 'cette dépense',
      update_expenses_lock: 'Mettez à jour votre bloc de dépenses',
      you_are_about_change_the_billing_status_of_one_expense: 'Vous êtes sur le point de modifier le statut de facturation des <b>dépenses</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de modifier le statut de facturation de <b>{number}dépense</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_lock_one_expense: 'Vous êtes sur le point de bloquer des <b>dépenses</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de bloquer <b>{number} dépenses</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_unlock_one_expense: 'Vous êtes sur le point de débloquer les <b>dépenses</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de débloquer <b>{number} dépenses</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_edit_one_project: 'Vous êtes sur le point de modifier le <b>projet</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de modifier <b>{number} projets</b>.<br/> Cette action nécessite une confirmation.',
      expense_deleted: '{number} dépenses supprimées | {number} dépenses éliminées',
      expense_updated: '{number} dépenses mises à jour | {number} dépenses mises à jour',
      any_projects: 'Tout projet',
      any_members: 'Tout membre',
      any_expense_category: 'Toute catégorie de dépenses',
      new_expense: 'Nouvelle dépense',
      set_expense_category: 'Définir la catégorie de dépenses',
      any_client: 'Tout client',
      any_group: 'N\'importe quel groupe'
    },
    attachments: {
      attachment: 'Pièce jointe | Pièces jointes',
      attach_file: 'Attacher un fichier',
      max_size: 'La taille maximale est de 50MB pour les images et de 3MB pour tous les autres types de fichiers.',
      download: 'Télécharger',
      remove: 'Retirer'
    },
    groups: {
      invalid_value: 'Valeur invalide',
      users_without_group: 'Utilisateurs sans groupe',
      invite_users: 'Inviter des utilisateurs',
      invite_team_member: 'Inviter des membres de l\'équipe',
      add_new_group: 'Ajouter un nouveau groupe',
      edit_team_member: 'Modifier un membre de l\'équipe',
      edit_group: 'Modifier le groupe'
    },
    groupDialog: {
      group_name: 'Nom du groupe',
      group_deleted: 'Le groupe a été éliminé',
      group_created: '{name} a été créé',
      info: 'Information',
      new_group: 'Nouveau groupe',
      member: 'Membre | Membres'
    },
    groupAddUserDialog: {
      all_team_member_is_part_of_group: 'Tous les membres de votre équipe font déjà partie d\'un groupe. Chaque membre de l\'équipe ne peut faire partie que d\'un seul groupe.',
      add_member_to: 'Ajouter un membre à {name}'
    },
    groupDeleteDialog: {
      any_user_will_be_removed: 'Tout utilisateur de ce groupe sera automatiquement supprimé des projets liés.',
      group_deletion: 'Supprimer le groupe',
      delete_group: 'Vous êtes sur le point de supprimer le groupe « {name} ».'
    },
    helpdesk: {
      watch_the_onboarding: 'Regardez l\'intégration',
      product_guide_faq: 'Guide produit et FAQ',
      contact_our_support_team: 'Contactez notre équipe d\'assistance',
      service_status: 'Statut des services',
      roadmap: 'Plan de développement',
      webapp_dev: 'webapp v.3.01.21 - {br} - Développé par',
      dm_digital: 'DM Digital Software S.R.L.',
      customize_layout: 'Personnalisez la présentation de votre tableau de bord en fonction de vos préférences',
      you_can_set_timers_automatically: 'Vous pouvez définir des minuteries pour qu\'elles s\'arrêtent automatiquement à une certaine heure et vous envoient une alerte',
      track_manage_time: 'Suivez et gérez votre temps dans vos applications Web préférées avec notre widget Chrome',
      can_export_entries: 'Saviez-vous que vous pouvez exporter vos enregistrements au format CSV et PDF ?',
      timeneye: 'Œil du temps'
    },
    integration: {
      sync_status: 'Sync',
      integration: 'Intégration',
      browser_widget: 'Widgets du navigateur',
      our_browser: {
        supports: 'Notre widget de navigateur prend en charge {0}.',
        web_app: '{el}application Web'
      },
      allows_track_time: 'Il vous permet d\'enregistrer votre temps directement sur {el} sans quitter leur application Web en ajoutant des données significatives aux entrées et aux minuteurs.',
      chrome: 'Chrome',
      firefox: 'Firefox',
      edge: 'Bord',
      synchronization_settings: 'Paramètres de synchronisation',
      each_row_manages_a_syncronization: 'Chaque ligne du tableau gère une fonctionnalité de synchronisation.',
      you_can_enable_a_feature: 'Vous pouvez activer une fonctionnalité en cliquant sur le bouton bascule et activer les notifications pour une fonctionnalité en cliquant sur l\'icône en forme de cloche.',
      refresh_authorization: 'Mettre à jour l\'autorisation',
      unlink_name: 'Déconnecter {name}',
      link_name: 'Connectez {name} à votre utilisateur',
      configuration: 'Configuration',
      integration_configurable_by_admin: 'Cette intégration ne peut être configurée que par un utilisateur administrateur.',
      data_security: 'Sécurité des données',
      requested_scopes: 'Zones obligatoires',
      purpose: 'Portée',
      privacy_and_security: 'Confidentialité et sécurité',
      timeneye_offers_seamless_integration_with_microsoft: "        Timeneye offre une int\xE9gration transparente avec les services Microsoft pour am\xE9liorer la productivit\xE9 et rationaliser la gestion des t\xE2ches.\n        Lors de l'int\xE9gration de Timeneye avec Microsoft, certaines autorisations et certains acc\xE8s aux donn\xE9es sont n\xE9cessaires pour garantir un fonctionnement fluide.\n        Ci-dessous, nous d\xE9crivons les autorisations et les donn\xE9es demand\xE9es pour les MS Teams CALLS.",
      call_records_ead_all: 'CallRecords.Read.All : cette portée donne à Timeneye un accès privilégié à callRecords pour chaque appel et réunion en ligne au sein de votre organisation, y compris les appels vers et depuis des numéros de téléphone externes.',
      with_these_permissions: 'Avec ces autorisations, Timeneye ajuste la durée des suggestions existantes importées depuis Outlook, pour correspondre aux appels passés dessus, et importe tous les appels non planifiés en tant que nouvelles suggestions.',
      what_data_does_timeneye_access_and_why: 'À quelles données Timeneye accède-t-il et pourquoi ? Lire l\'article complet.',
      timeneye_respects_user_privacy: '{0} Timeneye respecte la confidentialité des utilisateurs et se conforme aux réglementations en matière de protection des données. Toutes les données accessibles par les services Microsoft sont traitées de manière sécurisée et utilisées uniquement à des fins d\'intégration.',
      timeneye_employs_secure_authentication_mechanisms: '{0} Timeneye utilise des mécanismes d\'authentification sécurisés pour garantir que seuls les utilisateurs autorisés peuvent accéder aux intégrations Microsoft.',
      any_data_transmitted_between: '{0} Toutes les données transmises entre Timeneye et les services Microsoft sont chiffrées pour empêcher tout accès non autorisé.',
      data_protection: 'Protection des données',
      authentication: 'Authentification',
      data_encryption: 'Cryptage des données',
      by_granting_permissions_users_can_enjoy_benefits: "        En accordant ces autorisations, les utilisateurs peuvent profiter pleinement des avantages de l'int\xE9gration de Timeneye avec les services Microsoft,\n        am\xE9liorant la productivit\xE9 et l'efficacit\xE9 de la gestion des t\xE2ches tout en garantissant la s\xE9curit\xE9 et la confidentialit\xE9 des donn\xE9es.\n        Si vous avez des inqui\xE9tudes ou si vous avez besoin d'aide suppl\xE9mentaire, n'h\xE9sitez pas \xE0 {0}",
      contact_support_team: 'contactez notre équipe d\'assistance.'
    },
    integrations: {
      learn_more: 'En savoir plus',
      timeneye_browser_extension: 'Extension de navigateur Timeneye',
      install: 'Installer',
      please_install_our_browser_extension: 'Pour afficher les contrôles de suivi du temps dans votre outil préféré, installez notre extension de navigateur.{br}Voici à quoi nous ressemblons dans l\'interface. Assurez-vous de l\'installer sur n\'importe quel ordinateur que vous utilisez.',
      connect: 'Connecter',
      guides: 'Manuels',
      search_within_integrations: 'Rechercher parmi nos intégrations'
    },
    inviteUsersDialog: {
      you_have_x_licenses: 'Il vous reste {element} licences.',
      owners_can_add_licenses: 'Seuls les propriétaires peuvent ajouter plusieurs licences',
      remove_all_selected_users: 'Supprimer tous les utilisateurs sélectionnés',
      add_to_recommended: 'Ajouter à (recommandé)',
      select_group: 'Sélectionner un groupe',
      remove_user: 'Supprimer un utilisateur',
      temmates_invited: 'Vos collègues ont été invités !',
      can_see_when_temmates_join_your_workspace: {
        can_see_when_temmates_join: 'Vous pouvez voir quand vos collègues rejoindront {br} votre compte dans {team_section} ou {element}',
        team_section: 'Section équipe'
      },
      add_from_microsoft: 'Ajouter depuis Microsoft',
      add_from_google_workspace: 'Ajouter depuis Google Workspace',
      invite_new_team_members: 'Inviter de nouveaux membres de l\'équipe',
      add_more: 'Ajouter plus',
      invite: 'Inviter'
    },
    inviteUsersErrorsDialog: {
      proceed_to_dashboard: 'Accédez au tableau de bord',
      impossible_invite_some_users: 'Impossible d\'inviter certains utilisateurs',
      fake_mail: 'nom@organisation.com'
    },
    inviteUsersFromIntegrationDialog: {
      garant_permission: 'Accorder l\'autorisation à {name}',
      available_users: 'Utilisateurs disponibles',
      select_all_visible_users: 'Sélectionnez tous les utilisateurs visibles',
      error_retrieving_the_users_list: 'Une erreur s\'est produite lors de la récupération de la liste d\'utilisateurs de votre compte. Assurez-vous que le compte que vous choisissez est un compte professionnel.',
      authorization_refreshed: 'Autorisation mise à jour',
      retrieving_users: 'Récupération des utilisateurs...',
      automatically_import_team_mebers: {
        automatically_import: '{team_members} automatiquement dans Timeneye.{br}Tout ce que vous avez à faire est de nous accorder l\'autorisation d\'accéder à la liste des membres de votre équipe {element}.',
        team_members: 'importez les membres de votre équipe'
      },
      search_by_name: 'Rechercher par nom {name}',
      search_by_name_or_email: 'Rechercher par nom ou par email',
      invite_users_from: 'Inviter des utilisateurs de {name}',
      invite_team_by: {
        not_ready: 'Pas prêt à accorder la permission ? {invite_by_email}',
        invite_by_email: 'Invitez vos membres d\'équipe par email'
      },
      something_went_wrong_retrieving_users: 'Une erreur s\'est produite lors de la récupération de la liste d\'utilisateurs de votre compte. Assurez-vous que le compte que vous choisissez est un compte professionnel.'
    },
    keyboardShortcutsDialog: {
      open_register_time: 'Ouvrez la boîte de dialogue "Enregistrer maintenant".',
      open_entries: 'Ouvrir la liste "Enregistrements"',
      open_timers: 'Ouvrez la boîte de dialogue "Minuterie".'
    },
    management: {
      logout: 'Se déconnecter'
    },
    notifications: {
      no_notifications_available: 'Aucune notification disponible'
    },
    password: {
      at_least_8_character: 'Au moins 8 caractères',
      at_least_a_digit: 'Au moins un chiffre',
      at_least_a_capital_letter: 'Au moins une lettre majuscule',
      at_least_a_special_character: 'Au moins un caractère spécial'
    },
    phases: {
      use_phases_to: {
        track_time: 'Utilisez des phases pour suivre votre temps de manière plus organisée. {0}',
        learn_more: 'En savoir plus'
      },
      project_phases_activities: '(Phases/activités du projet - c\'est-à-dire avis, réunions, comptabilité)',
      the_phase_activity_category: '(La catégorie phase/activité, c\'est-à-dire Ventes, Marketing, Développement)',
      time_tracked: 'Temps <br />enregistré'
    },
    pickers: {
      all_element: 'Tous {el}',
      any_element: 'N\'importe quel {el}',
      date_format: 'Format des dates',
      after_creating_new_entry_timer: 'Après avoir créé un nouvel enregistrement/minuterie',
      close_form: 'Fermer le formulaire',
      leave_form_open: 'Laisser le formulaire ouvert',
      primary_action: 'Action primaire',
      interface_duration_format: 'Format de durée de l\'interface',
      reports_tables_duration_format: 'Format de durée du rapport et du tableau',
      first_day_of_week: 'Premier jour de la semaine',
      field_saved_automatically: 'Ce champ est automatiquement enregistré s\'il est modifié',
      deselect_all: 'Tout désélectionner',
      no_element_found: 'Aucun {el} trouvé.',
      invite_member: 'Inviter un nouveau membre',
      search_within: 'Rechercher dans {el}',
      search_within_tags: 'Rechercher dans les étiquettes',
      new_row_named: '{el} a appelé {input}',
      manage_tags: 'Gérer les étiquettes',
      requires_at_least_one_tag: 'Le projet sélectionné nécessite au moins un label par enregistrement',
      missing_tag_for_tag_list: 'Étiquette manquante pour le groupe d\'étiquettes demandé',
      add_tags_to_tag_list: 'Ce groupe d\'étiquettes n\'a aucune étiquette. Ajoutez-en un nouveau',
      select_one_or_more_type: 'Sélectionnez un ou plusieurs {el}',
      type_name: 'Nom {el}',
      no_el: 'non {el}',
      date_from: 'À partir du jour',
      date_to: 'À la date',
      create_new_element: 'Créer un nouveau {el}',
      create_new_option: 'Créer une nouvelle option',
      create_new_task_list: 'Créer une nouvelle liste de tâches',
      create_new_tag_list: 'Créer un nouveau groupe d\'étiquettes',
      no_selection: 'Aucune sélection',
      no_project_selected: 'Aucun projet sélectionné',
      picker: 'Sélecteur',
      option: 'Options | Possibilités',
      appLanguage: {
        beta: 'Certaines langues sont encore en version bêta. Si vous rencontrez des problèmes, veuillez nous en informer.'
      },
      description_non_billable: 'Heures de travail pour lesquelles le client ne sera pas facturé (par exemple, réunion d\'équipe)',
      description_billable: 'Entrées de temps qui peuvent être non facturées ou facturées',
      description_unbilled: 'Heures de travail pour lesquelles le client sera facturé.',
      description_billed: 'Heures travaillées que votre entreprise a déjà facturées aux clients.'
    },
    profile: {
      user_info: 'Informations utilisateur',
      app_settings: 'Paramètres de l\'application',
      suggestion: 'Suggestion',
      your_preferences_updated: 'Vos préférences ont été mises à jour',
      language: 'Langue',
      language_help_us: 'Veuillez noter que nos traductions sont encore en version bêta. Si vous remarquez des traductions incorrectes ou si vous avez des suggestions d\'amélioration, merci de nous le faire savoir ! Vous pouvez contribuer directement via {0}.',
      language_of_workspace: 'C\'est la langue qui sera utilisée pour votre compte.',
      number_formatting: 'Formatage des nombres',
      select_your_language: 'Sélectionnez votre langue pour formater les nombres selon les normes de votre pays.',
      this_wont_affect_language: 'Ces paramètres n\'affecteront pas la langue de l\'application.',
      date_and_country: 'Date et pays',
      country_and_timezone_settings: {
        settings: 'Les paramètres {0} sont utilisés pour afficher les dates et les heures en fonction de votre emplacement.',
        country_and_timezone: 'pays et fuseau horaire'
      },
      chose_fisrts_day_of_week_and_format: {
        chose: 'Choisissez {0} et {1} en fonction de vos préférences.',
        fisrts_day_of_week: 'premier jour de la semaine, week-end',
        date_format: 'format de date'
      },
      timeformats_are_used_for_entries: {
        are_used_for_entries: 'Les {0} sont utilisés pour les enregistrements et les minuteries dans le calendrier et les rapports.',
        timeformats: 'formats d\'horaires'
      },
      auto_stop_timers: 'Arrêt automatique des minuteries',
      select_when_to_autostop: {
        select_when_to: 'Sélectionnez l\'heure de la journée à laquelle Timeneye doit {0} régler automatiquement vos minuteries.',
        stop: 'arrêt'
      },
      hint_when_to_set_autostop: {
        when_to_set_autostop: '{0} : définissez l\'enregistrement automatique en fonction de l\'heure de fermeture du bureau.',
        hint: 'Suggestion'
      },
      enable_autostop: 'Activer l\'arrêt automatique',
      send_email: 'Envoyer un email',
      stop_timers_at: 'Arrêtez les minuteries à',
      register_time_form: 'Formulaire d\'enregistrement du temps',
      primary_action_will_switch_entries_timers: 'Les paramètres d\'action principale remplaceront les boutons d\'enregistrement/minuterie par "Enregistrement".{br}Les raccourcis clavier seront modifiés en conséquence.',
      whats_best_for_me: 'Qu\'est-ce qui est le mieux pour moi ?',
      if_you_have_entries: "Si vous ins\xE9rez des entr\xE9es seulement \xE0 la fin de la journ\xE9e, vous pouvez \xEAtre plus confortable\n      en d\xE9finissant \xAB Entr\xE9e \xBB comme action principale et en laissant le formulaire\n      ouvert apr\xE8s avoir cr\xE9\xE9 des entr\xE9es de temps. Si vous suivez le temps\n      en d\xE9placement, vous pouvez pr\xE9f\xE9rer avoir \"Timer\" comme action principale et \xE0\n      que le formulaire soit ferm\xE9 automatiquement.",
      if_you_have_large_number_of_projects: "If you have a large number of projects and clients you should\n      enable the client filter.<br />This way you'll be able to filter\n      projects by client.",
      show_client_filter: 'Afficher le filtre client',
      speeds_time_by_crating_suggestion: {
        speeds_time: 'Timeneye accélère votre expérience de suivi du temps {0} en fonction de votre activité quotidienne et de vos intégrations.',
        creating_suggestions: 'créer des suggestions'
      },
      all_sugestion_older_than_30: 'Toutes les suggestions datant de plus de 30 jours sont automatiquement supprimées.',
      new_to_timeneye: 'Si vous commencez tout juste à utiliser Timeneye, vous devrez peut-être attendre quelques jours avant de voir des suggestions.',
      enable_old_suggestion_style: 'Activer l\'ancien style de suggestion',
      system_emails: 'E-mail système',
      system_emails_cannot_be_disabled_message: {
        message: "          {system_emails_cannot_be_disabled}\n          {br}Ils incluent les invitations des utilisateurs, les factures,\n          alertes de facturation/abonnement, exports de donn\xE9es, suppression d'espace de travail,\n          alertes de s\xE9curit\xE9 et communications des administrateurs de votre compte.",
        system_emails_cannot_be_disabled: 'Les e-mails du système ne peuvent pas être désactivés'
      },
      onboarding_emails: 'E-mail d\'intégration',
      emails_to_guide_trial: 'Une série d\'e-mails pour vous guider pendant votre période d\'essai.',
      daily_reminder: 'Rappel quotidien',
      will_understand_how_many_hours: "Une fois que vous l'aurez utilis\xE9 pendant un certain temps, Timeneye comprendra\n      le nombre d'heures par jour que vous travaillez habituellement. Activer le rappel quotidien\n      vous enverra un e-mail lorsque vous oubliez de suivre votre temps ou si\n      vous suivez moins que d'habitude.",
      weekly_status: 'Statut hebdomadaire',
      recive_email_teamm_tracked: 'Recevez un e-mail avec un rapport de statut pour voir ce que votre équipe a suivi au cours de la semaine dernière.',
      feature_avaiable_for_pm_admin: 'Cette fonctionnalité est disponible pour les PM et les administrateurs.',
      automation_emails: 'E-mails d\'automatisation',
      enable_for_email_from_automations: 'Activez cette option pour pouvoir recevoir des e-mails des automatisations et pouvoir créer des automatisations liées aux rapports planifiés.',
      news_from_team: 'Des nouvelles de l\'équipe',
      recive_newsletter: 'Recevez une newsletter pour informer nos utilisateurs des dernières fonctionnalités publiées et des actualités de Timeneye.',
      will_send_newsletter_once_a_month: {
        will_send_newsletter: 'Nous enverrons la newsletter {0}',
        max_once_month: 'maximum une fois par mois.'
      },
      api_updates: 'Mises à jour des API',
      if_you_use_our_api: 'Si vous utilisez notre API nous vous recommandons de vous inscrire à cette liste de diffusion.',
      daily_recap: 'Récapitulatif quotidien',
      daily_recap_description: 'Recevez un récapitulatif quotidien de votre temps suivi.',
      expires_at: 'Expire à',
      revoke: 'Révoquer',
      copy_token: 'Copiez le jeton suivant dans un endroit sûr',
      you_wont_be_able_access: 'Vous ne pourrez plus accéder à ces informations à l\'avenir',
      issue_new_personal_tocken: 'Émettre un nouveau jeton d\'accès personnel',
      give_this_token_name: 'Donnez à ce jeton un nom mnémonique',
      revoke_access_token: 'Révoquer le jeton d\'accès',
      are_you_sure_removing_token: 'Êtes-vous sûr de vouloir procéder à la révocation du jeton nommé <strong>{el}</strong> ?<br/>Toutes les applications qui l\'utilisent actuellement perdront leur session d\'authentification.',
      token_copied: 'Jeton copié dans le presse-papiers',
      listed_personal_token: 'Les jetons d\'accès personnels délivrés à votre utilisateur sont répertoriés ici.',
      bearer_token_issued_by_personal_access: {
        bearer_token_issued: "Le jeton Bearer \xE9mis par un jeton d'acc\xE8s personnel peut \xEAtre utilis\xE9 pour s'authentifier aux API sans cr\xE9er une application \xE0 partir du portail d\xE9veloppeur.{br}{br}\n        Pour authentifier les requ\xEAtes, remplir l'en-t\xEAte HTTP \"Authorization\" avec {bearer_token}",
        bearer_token: '"Porteur <jeton>"'
      },
      personal_access_token_expire: {
        token_expire: 'Les jetons d\'accès personnels expirent après le jour {one_year} et ne peuvent pas être actualisés.{br}',
        one_year: 'un an'
      },
      please_visit_api: {
        please_visit: 'Pour plus d\'informations, visitez {0}',
        api_documentation: 'Page de documentation de l\'API'
      },
      authorized_apps: 'Applications autorisées',
      listed_third_party_apps: 'Les applications tierces que vous avez autorisées sont répertoriées ici.',
      legacy_apps_are_scheduled: 'Les anciennes applications devraient être retirées fin 2024.',
      created_by: 'Créé par',
      no_apps_authorized: 'Aucune application autorisée',
      revoke_app: 'Révoquer l\'application',
      revoke_access_to_app: 'Êtes-vous sûr de vouloir révoquer votre accès à l\'application {el} ?',
      access_to_app_revoked: 'L\'accès à l\'application a été révoqué.',
      avatar_visible_to_you_and_members_of_team: 'Cet avatar sera visible par vous et les membres de votre équipe.',
      drop_image: 'Déposez votre image n\'importe où ou cliquez ici pour sélectionner depuis votre appareil',
      max_image_size: 'Taille maximale de téléchargement 2 M (jpg, jpeg, png, bmp, svg, webp)',
      name_will_be_visible_to: 'Votre nom sera visible par tous les membres de l’équipe de l’espace de travail auxquels vous êtes lié en fonction des configurations de votre espace de travail.',
      email_will_be_visible_to: 'Votre e-mail sera visible par tout administrateur de l\'espace de travail auquel vous êtes connecté.',
      enter_new_email: 'Saisissez votre nouvelle adresse e-mail.{br}Vous recevrez un e-mail contenant un code de confirmation.',
      confirmation_code: 'Code de confirmation',
      enter_the_code: 'Saisissez le code que vous avez reçu dans le nouvel e-mail.{br}Le code expirera au bout de 10 minutes.',
      change_password: 'Changer le mot de passe',
      keep_information_safe: 'Pour protéger vos informations, votre mot de passe doit comporter au moins 8 caractères et contenir un chiffre et un caractère spécial.',
      you_will_be_logged_out: 'Remarque : Si vous modifiez votre mot de passe, vous serez déconnecté de toutes les sessions mobiles.',
      add_another_account: 'Ajoutez un autre compte Timeneye pour pouvoir basculer entre eux depuis le coin supérieur droit.',
      too_many_attempts: 'Trop de tentatives',
      token_name: 'Nom du jeton',
      third_party_apps: 'Applications tierces',
      day_picker_label_on: 'Le',
      time_picker_label_at: 'à',
      actions: 'Actes',
      edit_email: 'Modifier l\'e-mail',
      updated_last_email: 'E-mail mis à jour',
      updated_last_password: 'mot de passe mis à jour'
    },
    project: {
      add_users_to_all_selected: 'Ajouter des utilisateurs à tous les projets sélectionnés',
      you_have_been_flagged_as: 'Vous avez été marqué comme "{el}" de ce projet.',
      this_project_is_public: 'Ce projet est public et automatiquement disponible pour tous les {br} membres de l\'espace de travail.',
      project_flagged_as_api: 'Ce projet est marqué comme API uniquement. Tout enregistrement/minuterie sur {br}ce projet est bloqué.',
      project_linked_with: 'Projet lié à {el}',
      all_active_projects: 'Tous les projets actifs',
      all_archived_projects: 'Tous les projets archivés',
      my_active_projects: 'Mes projets actifs',
      my_archived_projects: 'Mes projets archivés',
      sync_el_data: 'Synchroniser les données {el}',
      project_syncing: 'Le projet est en phase de synchronisation',
      edit_team: 'Modifier l\'équipe',
      edit_phases: 'Modifier les phases',
      edit_tags: 'Modifier les étiquettes'
    },
    projectedit: {
      btn_bulk_edit: 'Édition collective',
      group_name: 'Groupe {name}',
      remove_member_from_project: 'Supprimer un membre du projet',
      no_user_linked_to_project: 'Il n\'y a aucun utilisateur connecté à ce projet',
      members_total_budget: 'Budget total des membres :',
      project_budget: 'Budget du projet :',
      demo_cannot_be_archived: 'Les projets de démonstration ne peuvent pas être archivés',
      duplicate_project: 'Projet en double',
      project_is_archived: 'Ce projet est archivé',
      projects_is_api_only: 'Ce projet est uniquement API',
      project_is_public: 'Ce projet est public',
      all_workspace_members: {
        part_of_project: 'Tous les membres de l\'espace de travail font partie de ce projet et de {may_not_be_added}.{br}Les administrateurs peuvent modifier ce paramètre dans l\'onglet "Informations".',
        may_not_be_added: 'ils ne peuvent être ni ajoutés ni supprimés'
      },
      last_edit_name_time: 'Dernière modification par {name} le {time}',
      project_duplicated: 'Projet en double',
      add_my_group: 'Ajouter mon groupe',
      select_a_group: 'Sélectionnez un groupe',
      remove_group_from_project: 'Supprimer le groupe du projet',
      no_group_linked: 'Il n\'y a aucun groupe connecté à ce projet',
      select_group_to_add: 'Sélectionnez un groupe à ajouter',
      error_while_adding_group: 'Erreur lors de l\'ajout du groupe',
      budget_recurrence: 'Anniversaire budgétaire',
      public_project: 'Projet public',
      all_workspace_member_are_added: 'Tous les membres de l\'espace de travail sont ajoutés aux projets publics. Seuls les propriétaires/administrateurs peuvent définir des projets comme publics.',
      is_billed_per_hour: 'Il est facturé à l\'heure',
      task_management: 'Gestion des tâches',
      enable_task_manager: "Enable task management for your project. You can always change this later. <br>\n      In case the project is linked to an integration, the tasks will be automatically imported from the integration. <br>\n      In case the integration does not support Tasks import, this section will not be available. <br>",
      enable_task_section: 'Activer la section tâches',
      task_are_not_avvaiable: 'Les tâches ne sont pas disponibles pour {el} projets à l\'heure spécifiée.',
      api_lock: 'Bloc API',
      enable_the_api_look: 'Activez l\'option API Lock si vous souhaitez verrouiller n\'importe quel enregistrement/minuterie sur ce projet.',
      it_may_be_useful: 'Cela peut être utile pour les projets qui doivent être alimentés uniquement par des applications tierces.',
      api_only: 'API uniquement',
      only_admin_can_make_project_api_only: 'Seuls les administrateurs ne peuvent créer qu\'une seule API de projet.',
      basic_info: 'Informations de base',
      set_name_an_color: 'Définissez un nom, une couleur et une description pour votre projet.',
      this_phases_is_linked: 'La phase est connectée à {el} et ne peut pas être modifiée.',
      phase_linked_with: 'Phase connectée à {el}',
      edit_tha_phase_name: 'Remplacez le nom de la scène par {el}',
      there_are_no_phases_linked: 'Il n\'y a aucune phase liée à ce projet',
      phases_total_budget: 'Budget total des phases',
      the_integration: 'intégration',
      tags_provide_more_precise_description: "Les balises fournissent une description plus pr\xE9cise de votre temps de travail, servant de m\xE9thode suppl\xE9mentaire de cat\xE9gorisation pour les projets complexes.\n      Chaque entr\xE9e peut \xEAtre assign\xE9e \xE0 une ou plusieurs balises par l'utilisateur.",
      enter_short_description: 'Entrez une brève description du projet',
      add_tags_to_project: 'Ajouter des étiquettes au projet',
      archived_last_project: 'Projet archivé',
      deleted_project: 'Projet supprimé',
      delete_phase: 'Supprimer la phase',
      unarchived_last_project: 'Projet restauré',
      billing__and_budget: 'Facturation et budget',
      set_up_client_budget_hourlyrate: 'Fixez un client, un budget, un taux horaire pour votre projet ou ouvrez le projet à toute votre équipe.',
      only_owner_can_update: 'Seuls les propriétaires peuvent mettre à jour la facturation et le budget d\'un projet non facturable.',
      users_total_budget: 'Budget utilisateur total'
    },
    projects: {
      search_within_projects: 'Rechercher dans les projets',
      you_are_about_to_change_client_for_one_project: 'Vous êtes sur le point de changer de client pour le <b>projet</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de changer de client pour <b>{number} projets</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_to_edit_one_project: 'Vous êtes sur le point de modifier le <b>projet</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de modifier <b>{number} projets</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_to_add_element_into_project: 'Vous êtes sur le point d\'ajouter un <b>projet</b> à {el}.<br/> Cette action nécessite une confirmation | Vous êtes sur le point d\'ajouter <b>{number} projets</b> à {el}.<br/> Cette action nécessite une confirmation.',
      api: 'Apis',
      add_users_to_all_projects: 'Ajouter des utilisateurs à tous les projets sélectionnés',
      add_phases_to_all_projects: 'Ajouter des étapes à tous les projets sélectionnés',
      add_groups_to_all_projects: 'Ajouter des groupes à tous les projets sélectionnés',
      number_project_unchanged: 'Un projet inchangé. Les projets de démonstration ne peuvent pas être archivés. | {number} projets inchangés. Les projets de démonstration ne peuvent pas être archivés.',
      set_client: 'Définir le client',
      set_client_to_all_projects: 'Définir le client sur tous les projets sélectionnés'
    },
    projectBudgetManagement: {
      only_owner_can_set_monetary_budget: 'Seuls les propriétaires peuvent définir un budget monétaire pour les projets non facturables',
      for_non_billable_projects: 'Pour les projets non facturables, les frais générés par les inscriptions sont comptabilisés au budget.',
      also_have_option_set_hourly_rates_from_user: {
        also_have_option_set_hourly_rates: 'FACULTATIF : vous avez également la possibilité de définir des tarifs horaires pour chaque membre de l\'équipe à partir de l\'onglet {0}.',
        user: 'Utilisateur'
      },
      also_have_option_set_hourly_rates_from_member_section: 'FACULTATIF : Vous avez également la possibilité de définir des taux horaires pour chaque membre de l\'équipe à partir de la section Membres.',
      also_have_option_set_time_budgets_per_tag: 'FACULTATIF : Vous avez également la possibilité de définir des budgets de temps pour <router-link to="#tags">Tag</router-link>, <router-link to="#users">Utilisateur</router-link> ou <router-link to="#phases">Phase</router-link> depuis les sections correspondantes.',
      also_have_option_set_time_budgets_per: {
        also_have_option: 'FACULTATIF : Vous avez également la possibilité de définir des budgets temps pour {0}, {1} ou {2} à partir des sections correspondantes.',
        tag: 'Étiquette',
        user: 'Utilisateur',
        phase: 'Phase'
      },
      also_have_option_set_time_budgets_from_corresponding_sections: 'FACULTATIF : Vous avez également la possibilité de définir des budgets temps par étiquette, membre ou phase à partir des sections correspondantes.',
      budget_resets_every: 'Le budget est réinitialisé tous les',
      on_up_btn_budget_recurence_weekly: 'Le',
      starting_from_up_btn_budget_recurence_monthly: 'Le',
      send_email_alert: 'Envoyer une alerte email si le projet réussit',
      of_budget_after_input_alert_threshold: 'du budget',
      include_expense_in_budget: 'Incluez les dépenses dans le calcul de votre budget',
      please_note_time_marked: {
        please_note_timers_marked: '{0} inscriptions marquées comme "non facturables" seront {1} calculées dans le budget du projet.',
        time_entries_and_expenses_marked: '{0} inscriptions et dépenses marquées comme "non facturables" seront {1} calculées dans le budget du projet.',
        please_note: 'VEUILLEZ NOTER:',
        not: 'Pas'
      }
    },
    pricingBillingCard: {
      upgrade_your_account: 'Mettez à niveau votre plan et obtenez plus de fonctionnalités',
      select_best_plan: 'Sélectionnez le meilleur plan qui répond à la taille de votre équipe et aux objectifs de votre entreprise',
      not_ready: {
        downgrade_to: 'Pas encore prêt ? Passez à notre {free_plan}',
        free_plan: 'Plan gratuit'
      },
      annual_billing: 'Facturation annuelle',
      monthly_billing: 'Facturation mensuelle',
      per_time: {},
      per_month: 'par utilisateur/mois',
      billed_monthly: 'montant facturé mensuellement',
      billed_yearly: 'facturé annuellement',
      custom_pricing: 'Tarification personnalisée',
      up_to_limit_users: 'Jusqu\'à {number} utilisateurs',
      unlimited_users: 'Utilisateurs illimités',
      more_users: 'Besoin de plus d\'utilisateurs ? {contact}',
      contact_us: 'Contacter l\'assistance',
      everything_in_plan: 'Tout dans le plan {previous_plan}, plus',
      billing_platform: 'Plateforme de facturation',
      start_subscription_for: {
        you_are_about_to: 'Vous êtes sur le point de commencer votre abonnement pour le {pro}',
        pro_plan: 'Plan Pro'
      },
      what_billing_prefer: 'Quelle plateforme de facturation préférez-vous ?',
      microsoft_marketplace: 'Marketplace Microsoft',
      phurchase_subscription: 'Achetez votre abonnement sur le Microsoft marketplace',
      start_subscription: 'Démarrez votre abonnement',
      stripe: 'Stripe',
      use_your_credit_card: 'Utilisez les informations de votre carte de crédit pour procéder au paiement',
      current_plan: 'Abonnement actuel',
      subscribe: 'S\'abonner',
      talk_to_sales: 'Parler aux ventes',
      upgrade: 'Mettre à niveau',
      downgrade: 'Rétrograde',
      try_plan: 'Essayer le plan',
      you_want_to_switch: 'Si vous souhaitez passer au Plan Gratuit, vous devez {archive_users} car le Plan {br} Gratuit n\'inclut que 2 utilisateurs.',
      you_want_to_downgrade: 'Souhaitez-vous passer au Plan Gratuit ? {contact_us}',
      archive_number_users: 'archiver {number} utilisateurs',
      legacy_plan: 'Ceci est maintenant un plan hérité.',
      legacy_plan_description: 'Tous les utilisateurs de ce plan conserveront les fonctionnalités qu\'ils utilisent actuellement.<br/>Pour une liste complète des fonctionnalités de ce plan, veuillez consulter le tableau ci-dessous. ',
      switch_to_free: 'Passer à l\'offre gratuite',
      successfully_switched_to_free: 'Vous avez réussi à passer au plan gratuit.'
    },
    projectDialog: {
      insert_project_name: 'Entrez le nom du projet',
      project_name_required: 'Un nom de projet est requis.',
      make_project_public: 'Rendre le projet public',
      all_workspace_members_added_to_public_projects: 'Tous les membres de l\'espace de travail sont ajoutés au projet public',
      chose_members_to_add: 'Choisissez les membres à ajouter',
      invite_new_users: 'Inviter de nouveaux utilisateurs',
      press_enter_to_add_phase: 'appuyez sur "enter" pour ajouter une nouvelle phase',
      created_project: 'Projet créé',
      general: 'Général',
      project_details: 'Détails du projet',
      member: 'Membre | Membres',
      project_type: 'Type de projet'
    },
    projectAddUserDialog: {
      add_team_members: 'Ajouter des membres de l\'équipe',
      user_not_found: 'Utilisateur introuvable',
      all_members_already_in_project: 'Tous les membres de votre équipe font déjà partie de ce projet',
      search_user: 'Rechercher un utilisateur',
      to_name: 'à {name}'
    },
    projectArchiveDialog: {
      you_are_about_to_archive_x_projects: 'Vous êtes sur le point d\'archiver {num_project} projets',
      will_be_ignored: 'sera ignoré. Les projets de démonstration ne peuvent pas être archivés.',
      archive_projects: 'Projets d\'archives'
    },
    projectFromTemplateDialog: {
      template: 'Modèle',
      new_project_name: 'Nouveau nom du projet'
    },
    projectUpdateWarningDialog: {
      attention_required: 'Attention requise',
      deleting: 'Élimination',
      all_entries_in_phase: {
        will_be_deleted: 'VEUILLEZ NOTER : TOUTES les entrées de ce {element} seront supprimées {permanently}.{br}Si vous ne souhaitez pas perdre ces entrées, nous vous recommandons de les déplacer vers une autre phase avant de sauvegarder ou d\'archiver {element}.',
        permanently: 'en permanence'
      },
      removing: 'Suppression',
      member_will_no_longer_track_time: 'Ce membre ne pourra plus enregistrer du temps sur ce projet mais pourra toujours consulter ses anciens enregistrements sur ce projet. | Ces membres ne pourront plus enregistrer du temps sur ce projet mais pourront toujours consulter leurs enregistrements sur ce projet.',
      all_members_of_group_no_longer_track_time_on_tag: 'Les membres ne pourront plus enregistrer de temps pour ce label sur ce projet. | Les membres ne pourront plus enregistrer de temps pour ces labels sur ce projet.',
      sum_of_elements_exceeds_projects_budget: {
        sum_of_elements: 'La somme des budgets des membres/phases/tags dépasse le budget du projet.{br}{project_will_be_updated}',
        project_will_be_updated: 'Le budget du projet sera mis à jour en conséquence.'
      },
      confirm_and_save: 'Confirmer et enregistrer'
    },
    projectsDeleteDialog: {
      entries_deleted: {
        all_entries_going_to: 'TOUS les enregistrements sur ces projets {0}.',
        deleted_from_it: 'sera éliminé'
      },
      sugestion_and_timers_deleted: {
        all_timers_and_sugestion: 'TOUS les minuteurs et suggestions actuellement liés à ces projets {0}.',
        be_deleted: 'sera supprimé'
      },
      dont_want_to_lose_project: 'Si vous ne souhaitez pas perdre vos données, nous vous recommandons d\'archiver ce projet. | Si vous ne souhaitez pas perdre vos données, nous vous recommandons plutôt d\'archiver ces projets.',
      delete_projects: 'Supprimer des projets'
    },
    projectsInvoiceDialog: {
      billed_money: 'Montant facturé',
      total_billable_amount: 'Montant total facturable',
      billed_amount: 'Montant facturé',
      unbilled_amount: 'Montant non facturé',
      there_are_invoice: 'Il n\'y a pas de factures pour ce projet.',
      amount_updated: 'Montant mis à jour'
    },
    phasesDialog: {
      serch_within_phases: 'Rechercher dans les phases',
      manage_phases_dsa: 'Gérer les phases'
    },
    phaseDialog: {
      with_name: 'avec le nom {name}',
      set_all_elements: {
        set_all: 'Définir tous les {0} comme première ligne',
        categories: 'catégories',
        names: 'noms'
      },
      bulk_actions: 'Bloquer les actions'
    },
    phaseCategoriesDialog: {
      phase_category_saved: 'Catégories de phases enregistrées.',
      error_saving_phase: 'Erreur lors de l\'enregistrement des catégories de phase.',
      missing_field_name: 'Il manque un nom à un ou plusieurs champs.',
      phase_category_name: 'Nom de la catégorie de phase'
    },
    pickerDialog: {
      select_expense_category: 'Sélectionnez une catégorie de dépenses',
      select_element: 'Sélectionnez {el}'
    },
    report: {
      edit_report_name: 'Changer le nom du rapport',
      report_scheduled: 'Rapport programmé. Prochaine exécution : {el}',
      rounding: 'Arrondi',
      round_mode: 'Mode rond',
      round_minutes: 'Minutes rondes',
      round_to_up_to: 'Rassembler',
      round_to_nearest: 'Arrondir au plus proche',
      round_to_down_to: 'Arrondir vers le bas',
      x_minutes: '{el} minutes | {el} minutes',
      x_hour: '{el} maintenant | {1 heure',
      type_report: '{type_report} rapport',
      some_data_has_changed: 'Certaines données ont changé depuis la dernière génération du rapport',
      generete_pdf_error: 'Une erreur s\'est produite lors de la génération du PDF',
      genereting_file: 'Génération de {el}...',
      as_type_file: 'en tant que fichier {element}',
      group_by: 'Regrouper par',
      breakdown_by: 'Répartition par',
      ungrouped: 'Non groupé',
      untagged: 'Sans étiquette',
      uncategorized: 'Non classé',
      no_todo: 'Aucune tâche',
      no_client: 'Aucun client',
      to_open_entries_log: 'Pour ouvrir des enregistrements sur une phase, vous devez filtrer pour un seul projet',
      visible_data: 'Données visibles',
      recurence_resets: {
        resets: '{recurence} se réinitialise sur {element}',
        recurence: 'Anniversaire:'
      },
      open_timesheet_dialog: 'Ouvrir dans la boîte de dialogue Feuille de temps',
      billed_amount: 'Montant facturé',
      unbilled_amount: 'Montant non facturé',
      your_roi: {
        your_roi_is: 'Félicitations! Votre retour sur investissement est de {your_roi} % (ROI = (argent facturé - coûts totaux) / coûts totaux x 100)',
        your_current_roi_is: " Votre ROI actuel est {your_roi}% (ROI = (total factur\xE9 - co\xFBt total) / co\xFBt total x 100){br}\n        Votre ROI {estimated} est {estimate_roi}% (argent factur\xE9 + argent non factur\xE9 - co\xFBt total) / co\xFBt total x 100)",
        negative_current_roi: "Votre ROI actuel est {your_roi}% (ROI = (total factur\xE9 - co\xFBt total) / co\xFBt total x 100){br}\n        Votre ROI {estimated} est {estimate_roi}% (argent factur\xE9 + argent non factur\xE9 - co\xFBt total) / co\xFBt total x 100)",
        estimated: 'Estime'
      },
      open_expenses_page: 'Ouvrir la page des dépenses',
      internal_costs: 'Coûts internes',
      column_disabled_because_no_budget: 'Cette colonne est désactivée car le projet n\'a pas de budget. Modifier le projet pour ajouter un budget',
      project_not_billable: 'Le projet sélectionné n\'est pas facturable',
      single: 'Célibataire',
      cumulative: 'Cumulatif',
      expand_to_see_budgets: 'Développer pour afficher les budgets',
      your_subscription_dosnt_support: 'Votre abonnement actuel ne prend pas en charge la gestion de projet',
      duplicate: 'Double',
      effort: 'Effort',
      metric: 'Métrique',
      new_type_report: 'Nouveau rapport {type}',
      no_data_for_curent: 'Aucune donnée pour la {br}période en cours',
      schedule: 'Plan',
      save_report: 'Enregistrer le rapport',
      from_date_to_date: '<span style="font-size: 10px">de</span> {date_from} <span style="font-size: 10px">de</span> {to_date}',
      total_expenses: 'Dépenses totales',
      last_version_support: {
        historical: "La derni\xE8re version de Timeneye supporte les taux historiques.{0}\n          Par cons\xE9quent, les informations financi\xE8res contenues dans les rapports de la version ant\xE9rieure peuvent diff\xE9rer de la nouvelle version.{0}{1}",
        learn_more: 'En savoir plus'
      },
      error_while_generating_csv: 'Une erreur s\'est produite lors de la génération du CSV'
    },
    reports: {
      templates_gallery: 'Galerie de modèles',
      recent_reports: 'Rapports récents',
      scheduled: 'Programmé',
      next_run: 'Prochaine exécution',
      create_new_report_from: 'Créer un nouveau rapport à partir de zéro',
      monitor_your_project: 'Suivez vos projets et respectez votre budget',
      get_real_time_insights: 'Obtenez des informations en temps réel sur l\'engagement de votre équipe',
      bill_accurately: 'Facturation précise et livraison dans les délais',
      keep_track_of_billable: 'Suivez les heures facturables et non facturables',
      dive_deeper: 'Approfondissez vos données avec un rapport sur les étiquettes',
      blank: 'Vide',
      deleted_report: 'Rapport supprimé'
    },
    estimateLogDialog: {
      title: 'Journal des estimations',
      no_log_entries: 'Aucune entrée de journal trouvée.',
      log_entry: 'À {time}, {name} {action} l\'estimation de la tâche :',
      created: 'a créé',
      updated: 'a mis à jour',
      edit_task: 'Modifier la tâche'
    },
    recurrenceSuggestionDeleteDialog: {
      remove_only_this_occurrence: 'Supprimer uniquement cette occurrence',
      disable_recurrent_event: 'Désactiver cet événement récurrent',
      ignore_recurrent_event: 'Ignorer l\'événement récurrent'
    },
    registerTimeDialog: {
      select_task: 'Sélectionnez une tâche',
      entry_created: 'Inscription créée',
      update_entry: 'Mettre à jour l\'inscription',
      update_timer: 'Minuterie de mise à jour',
      open_link: 'lien ouvert',
      can_edit_locked_entry: 'Étant donné votre rôle, vous pouvez modifier cette entrée',
      edit_entry: 'Modifier',
      new_version: 'Nouvelle version'
    },
    setup: {
      welcome_to_timeneye: 'Bienvenue sur Timeneye !',
      you_have_been_invited: 'Vous avez été invité à participer',
      insert__full_name: 'Entrez votre nom complet',
      min_length_name: 'Votre nom complet doit contenir au moins 3 caractères',
      timeneye_will_monitor_your_progress: 'Timeneye vous aidera à suivre vos progrès, à respecter votre budget et à visualiser votre effort quotidien',
      name_your_workspace: 'Donnez un nom à votre compte',
      min_length_company_name: 'Le nom de votre entreprise doit contenir au moins 3 caractères',
      your_primary_role: 'Quel est votre rôle principal ?',
      tailor_your_workspace: 'Cela nous aidera à personnaliser votre compte selon vos besoins',
      choose_an_option: 'Choisissez une option',
      please_choose_option: 'Veuillez choisir une option',
      how_many_people_working: 'Avec combien de personnes allez-vous travailler ?',
      only_me: 'Juste moi',
      do_you_use_these_apps: 'Utilisez-vous l’une de ces applications ?',
      timeneye_can_integrate_with_tool: 'Timeneye peut s\'intégrer de manière transparente à votre outil préféré',
      remove_suggestion: 'Supprimer la suggestion',
      connect_microsoft: 'Liez votre compte Microsoft à Timeneye',
      this_will_let_you: 'Cela vous permettra',
      setting_up_your_workspace: 'Configurez votre compte',
      redirect_in_dashboard: 'Vous serez bientôt redirigé vers le tableau de bord',
      next: 'Après vous',
      grant_permissions: 'Accorder des autorisations',
      bring_calendar_events: 'Intégrez les événements de votre calendrier dans votre tableau de bord Timeneye pour suivre facilement le temps de vos réunions et événements quotidiens.',
      sync_your_to_do: 'Synchronisez vos listes de tâches avec Timeneye pour suivre le temps passé sur vos tâches de travail et rester organisé',
      import_ms_planner: 'Importez vos projets MS Planner dans Timeneye, suivez vos tâches de travail et suivez vos progrès',
      inser_name_of_company: 'Entrez le nom de votre entreprise',
      owner_has_set_planner: 'Le propriétaire du compte a configuré l\'intégration de MS Planner et vous avez été automatiquement inclus. Il est donc important de garder cette option activée.',
      disabling_option: 'En désactivant cette option, vous perdrez la possibilité de suivre le temps passé sur les projets importés de MS Planner vers Timeneye par le propriétaire du compte.',
      leave_your_mobile_phone: 'Laissez votre numéro de portable pour l\'assistance à l\'intégration',
      insert_phone: 'Insérez votre téléphone',
      job_title_placeholder: 'C.-à-d. Responsable de projet, Développeur, CTO',
      workspace_creation: 'Création de l\'espace de travail',
      invite_team_to_timeneye: 'Invitez votre équipe à Timeneye',
      garant_permission: 'Accorder l\'autorisation',
      install_browser_widgt: 'Installer le widget de navigateur Timeneye',
      install: 'Installer',
      timeneye_browser: {
        embed_time_tracking: "Le widget du navigateur Timeneye vous permet d'int\xE9grer des contr\xF4les de suivi du temps dans l'interface de votre logiciel Microsoft pr\xE9f\xE9r\xE9, tel que {integrations}.{br}\n        Cela rend encore plus facile pour vous et votre \xE9quipe de remplir la feuille de temps avec pr\xE9cision.",
        integrations: 'MS Planner, MS To Do ou Jira'
      },
      import_team_into_timeneye: 'Importer les membres de votre équipe dans Timeneye.{br}Tout ce que vous avez à faire est de nous accorder l\'autorisation d\'accéder à la liste des membres de votre équipe Microsoft.',
      skip: 'Sauter',
      number_users: '0 utilisateurs sélectionnés|1 utilisateur sélectionné|{number} utilisateurs sélectionnés',
      back: 'Retour'
    },
    listableUsersFromIntegration: {
      invite_users_from_provider: 'Inviter des utilisateurs de {provider}'
    },
    scheduleReportDialog: {
      schedule_report: 'Planifier des rapports',
      report_name: 'Nom du rapport',
      schedule_every: 'Planifiez chaque',
      save_schedule: 'Enregistrer le programme',
      invalid_email_adress: 'adresse e-mail invalide',
      email_already_exist: 'Cette adresse email existe déjà.',
      press_add_or_enter: 'Appuyez sur "Ajouter" ou "Entrée" pour insérer cette adresse e-mail dans les destinataires',
      max_10_mails: 'Un maximum de 10 e-mails est autorisé.',
      send_email_to: 'Envoyez un e-mail à',
      share_report: {
        you_can_share: "Vous pouvez partager ce rapport avec un maximum de {with_10} {br}\n        Une fois leurs adresses e-mail v\xE9rifi\xE9es, ils recevront ce rapport r\xE9guli\xE8rement.",
        with_10: '10 personnes.'
      },
      only_me: 'Juste moi',
      me_others: 'Moi et les autres',
      share_with: 'Partager des rapports avec',
      recipient_maximum_warning: {
        to_add_you_have_to_remove: '{0} Pour ajouter d\'autres destinataires, vous devez en supprimer certains.',
        recipient_maximum_capacity: 'La liste des destinataires a atteint sa capacité maximale.'
      },
      recipients: 'Destinataires',
      remove_from_recipients: 'Supprimer un membre des destinataires',
      confirmed: 'Confirmé',
      pending: 'Dans l\'attente de',
      choosing_this: {
        all_mail_will_be_removed: '{0} Avertissement : En choisissant cette option, tous les destinataires d\'e-mail précédemment saisis seront supprimés de la liste et ne recevront pas votre rapport.',
        warning: 'Attention'
      }
    },
    sharedEmailDialog: {
      you_have_added_x_pepople: 'Vous avez ajouté {number} personnes à vos destinataires',
      when_email: {
        verified: "Une fois leurs adresses e-mail v\xE9rifi\xE9es, ils recevront ce rapport r\xE9guli\xE8rement. {br}\n          Ce rapport est partag\xE9 avec un {total_of_recipients}",
        total_of_recipients: 'total de {totalRecipientsCount} destinataires.'
      }
    },
    subscriptionTypeUpgrade: {
      upgrade_to: 'Cette fonctionnalité est incluse dans le ',
      free: 'Plan gratuit',
      starter: 'Plan Starter',
      premium: 'Plan Premium',
      enterprise: 'Plan Entreprise',
      not_owner_message: 'Pour accéder à cette fonctionnalité, vous devez demander au propriétaire de l\'espace de travail de mettre à niveau le plan d\'abonnement.',
      not_owner: 'Besoin de l\'approbation du propriétaire'
    },
    suggestionsDialog: {
      sugestion_for: 'Suggestions pour',
      suggestions_ignored: 'Suggestions ignorées',
      problem_ignoring_suggestions: 'Un problème est survenu lors de l\'ignorance d\'une ou plusieurs suggestions',
      ignore_all: 'Ignorer tout'
    },
    suggestIntegrationDialog: {
      always_open_to_suggestions: 'Chez Timeneye, nous sommes toujours ouverts aux suggestions pour améliorer notre produit.',
      write_name_of_software: 'Veuillez écrire le nom du logiciel avec lequel vous souhaitez qu\'il s\'intègre',
      please_write_name: 'Veuillez écrire le nom.',
      send: 'Envoyer'
    },
    switchEnvironmentDialog: {
      new_version: {
        rewritten: "La version h\xE9rit\xE9e de Timeneye sera interrompue \xE0 partir du 31 d\xE9cembre 2024. {br}\n              Si vous rencontrez des probl\xE8mes de blocage, merci de nous contacter en utilisant l' {support_chat}",
        support_chat: 'chat d\'assistance'
      },
      let_us_know_why_old_version: 'Faites-nous savoir pourquoi vous préférez l\'ancienne version. Plus vos commentaires sont détaillés, mieux nous pouvons améliorer notre produit et répondre à vos besoins.',
      prefer_old_version: 'Je préfère l\'ancienne version de Timeneye parce que...',
      switch_old_version: 'Revenir à l\'ancienne version'
    },
    switchUserDialog: {
      switch_user: 'Changer d\'utilisateur'
    },
    tagManagement: {
      select_tag_list: 'Sélectionner le groupe d\'étiquettes',
      unarchive_this_tag_list: 'Désarchivez ce groupe d\'étiquettes pour le sélectionner',
      create_a_tag: 'Créez une étiquette pour sélectionner ce groupe d\'étiquettes',
      create_or_unarchive: 'Créez une étiquette ou désarchivez une étiquette pour la sélectionner',
      create_without_adding: 'Créer sans ajouter',
      tag_list_already_linked: 'Ce groupe d\'étiquettes est déjà lié à {el} projets. </br> Voulez-vous ajouter ce label à tous les projets liés ?',
      add_tag_to_linked_projects: 'Ajouter une étiquette aux projets liés',
      search_within_tag_lists_tags: 'Rechercher dans les étiquettes et les groupes d\'étiquettes',
      show_archived_tag_lists_tags: 'Afficher les étiquettes et les groupes d\'étiquettes archivés',
      choose_from_preset: 'Choisissez parmi les préréglages',
      select_all_lag_list_tag: 'Sélectionnez toutes les étiquettes et groupes d\'étiquettes visibles',
      no_tag_list_matching: 'Aucun groupe de libellés ne correspond aux filtres.',
      tags_total_budget: 'Budget total sur les étiquettes',
      there_are_no_active_tag: 'Il n\'y a pas encore de groupes de libellés actifs dans votre compte.',
      add_a_new_one: 'Ajoutez-en un nouveau',
      open_in_timesheet: 'Ouvrir dans la liste d\'enregistrement',
      add_new_tag_list: 'Ajouter un nouveau groupe d\'étiquettes',
      add_new_tag: 'Ajouter une nouvelle étiquette',
      add_tag_to_projects: 'Ajouter une étiquette aux projets',
      archived_last_tag_list: 'Groupe d\'étiquettes archivée',
      archived_last_tag: 'Étiquette archivée',
      archive_tag_list: 'Groupe d\'étiquettes d\'archive',
      archive_tag: 'Étiquette d\'archive',
      created_last_tag_list: 'Groupe d\'étiquettes créé',
      created_last_tag: 'Étiquette créée',
      delete_tag_list: 'Supprimer le groupe d\'étiquettes',
      delete_tag: 'Supprimer l\'étiquette',
      delete_confirmation_tag_list: 'Voulez-vous supprimer ce groupe de libellés ?',
      delete_confirmation_tag: 'Voulez-vous supprimer ce libellé ?',
      edit_tag: 'Modifier l\'étiquette',
      remove_tag_list: 'Supprimer le groupe d\'étiquettes',
      remove_tag: 'Supprimer l\'étiquette',
      remove_tag_list_from_project: 'Supprimer le groupe d\'étiquettes du projet',
      remove_tag_from_project: 'Supprimer l\'étiquette du projet',
      reset_changes: 'Réinitialisez vos modifications',
      unarchive_tag_list: 'Réactiver le groupe d\'étiquettes',
      unarchive_tag: 'Réactiver l\'étiquette',
      updated_last_tag_list: 'Groupe d\'étiquettes mis à jour',
      updated_last_tag: 'Étiquette mise à jour',
      unarchived_last_tag_lsit: 'Groupe d\'étiquettes réactivé',
      unarchived_last_tag: 'Étiquette réactivée',
      save_tag_list: 'Enregistrer le groupe d\'étiquettes',
      save_tag: 'Enregistrer l\'étiquette',
      tag_list_confirmation_delete: 'Après confirmation, tout enregistrement associé aux étiquettes de ce groupe sera désétiqueté.',
      tag_confirmation_delete: 'Après confirmation, toute inscription associée à ce label en sera privée.',
      unarchive_this_tag: 'Réinitialisez ce libellé pour le sélectionner'
    },
    tasks: {
      browser_extension: 'Extension de navigateur'
    },
    timers: {
      paused_timers: {
        dont_have_active_paused_timers: 'Vous n\'avez aucun minuteur actif ou en pause.{br}{click_here}',
        click_here: 'Cliquez ici pour en démarrer un nouveau.'
      },
      dont_have_active_or_paused_timers: 'Vous n\'avez aucun minuteur actif ou en pause'
    },
    todoManagement: {
      sync_data: 'Synchroniser les données',
      integration_syncing: 'L\'intégration est en cours de synchronisation',
      todo_list_name: 'Nom de la liste de tâches',
      mark_not_completed: 'Marquer comme incomplet',
      mark_as_completed: 'Marquer comme terminé',
      set_due_date: 'Définir une date d\'expiration',
      task_removed: 'Tâche supprimée',
      rename: 'Rebaptiser',
      completed_tasks: 'Tâches terminées',
      search_within_tasks: 'Rechercher dans les tâches',
      add_new_task_list: 'Ajouter une nouvelle liste de tâches',
      create_new_task: 'Créer une nouvelle tâche'
    },
    tagListDialog: {
      tag_list_name: 'Nom du groupe d\'étiquettes',
      text_color: 'Couleur du texte',
      tag_name: 'Nom de l\'étiquette',
      tag_list_created: '{name} a été créé',
      add_tag_list: 'Ajouter un groupe d\'étiquettes | Ajouter des groupes d\'étiquettes',
      default: 'Défaut'
    },
    tagListDeleteDialog: {
      all_tags: {
        going_to_be_deleted: 'TOUTES les étiquettes de ce groupe seront immédiatement supprimées et {0} pourra être restauré.',
        not: 'Pas'
      },
      tag_list_deletion: 'Suppression du groupe d\'étiquettes',
      you_are_about_to_delete_taglist: 'Vous êtes sur le point de supprimer ce groupe d\'étiquettes.',
      taglist_deleted: 'Le groupe d\'étiquettes a été supprimé'
    },
    tagListPresentsDialog: {
      tag_list_presets: 'Groupes d\'étiquettes prédéfinis',
      select_one_of_our_presents: 'Sélectionnez l\'un de nos groupes prédéfinis pour démarrer votre compte.',
      tag_list_with_same_name_already_exist: 'Un groupe d\'étiquettes du même nom est déjà présent dans l\'espace de travail',
      copy_to_workspace: 'Copier dans la zone de travail'
    },
    tagDeleteDialog: {
      tag_deletion: 'Suppression des étiquettes'
    },
    tagsDialog: {
      add_selected_tags_to_project: 'Ajouter les étiquettes sélectionnées au projet'
    },
    todoDialog: {
      to_edit_go_back_to_integration: 'Pour apporter des modifications à cette tâche, revenez à {integration} et modifiez-la à partir de là. {br} Toutes les modifications que vous apportez seront automatiquement synchronisées avec Timeneye',
      open_in: 'Ouvert à {name}',
      assign_to: 'Attribué à',
      select_todo_list: 'Sélectionnez une liste',
      task_list_required: 'Une liste de tâches est requise',
      insert_start_date: 'Entrez la date de début',
      insert_due_date: 'Entrez la date d\'expiration',
      insert_task_name: 'Entrez le nom de votre entreprise',
      show_estimate_log: 'Afficher le journal',
      manage_task: 'Gérer les tâches',
      deleted_task: 'Tâche supprimée'
    },
    timersDialog: {
      save_all_as_entries: 'Enregistrez tout sous forme d\'enregistrements',
      timers_saved: 'Minuteries enregistrées',
      problem_occured_while_saving: 'Un problème est survenu lors de l\'enregistrement des minuteries'
    },
    users: {
      invite_from_microsoft: 'Invitation de Microsoft',
      invite_from_google_workspace: 'Invitation de Google Workspace',
      invite_by_email: 'Inviter par e-mail',
      pending: 'Dans l\'attente de',
      resend_invite: 'Renvoyer l\'invitation',
      user_invited_less_than_a_day: 'Cet utilisateur a été invité il y a moins de 24 heures',
      export: 'Exporter',
      set_members_working_time: 'Définir les horaires de travail des membres',
      set_members_hourly_rate: 'Fixer le taux horaire des membres',
      set_members_hourly_cost: 'Fixer le taux horaire des membres',
      set_manager: 'Définir le manager',
      invite_sent: 'Invitation envoyée',
      error_deactivating_user: 'Erreur lors de la désactivation de l\'utilisateur',
      users_activated: 'Utilisateurs activés',
      error_activating_user: 'Erreur lors de l\'activation de l\'utilisateur.',
      user_in_your_workspace: 'L\'utilisateur est déjà membre de l\'espace de travail',
      user_in_other_workspace: 'L\'utilisateur est déjà membre d\'un autre espace de travail',
      user_already_selected_for_invite: 'L\'utilisateur est déjà sélectionné pour l\'invitation',
      dep: '- Division : {el}',
      search_within_users: 'Rechercher parmi les membres',
      every: 'Tout va bien',
      invited_on: 'Invité sur',
      never: 'Jamais',
      last_seen_on: 'Vu pour la dernière fois le',
      last_entry_on: 'Dernière inscription le',
      gm_explain: {
        explain: '{gm} peut créer des projets, exécuter des {br}fonctions de gestion et exécuter des rapports, mais uniquement {br}pour les groupes sous sa gestion.',
        gm: 'Responsable de groupe'
      },
      pm_explain: {
        explain: '{pm} peut exécuter {br} fonctions de gestion et exécuter des rapports, mais uniquement pour les {br}projets actifs sous sa supervision.',
        pm: 'Chef de projet'
      },
      info_menu_roles: {
        info_owners: '{owners} ont accès à pratiquement toutes les {br} fonctionnalités et vues, y compris la gestion de votre {br} paiement et de votre abonnement et la suppression de l\'intégralité de votre espace de travail.{br}',
        info_admins: '{admins} possède toutes les fonctionnalités du propriétaire {br}, à l\'exception de la gestion de votre paiement et de votre abonnement à {br} et de la suppression de votre espace de travail. {br}',
        info_members: '{members} peut suivre le temps et modifier vos {br} paramètres personnels et intégrations.{br}',
        owners: 'Propriétaires',
        admins: 'Administrateurs',
        members: 'Membres'
      },
      info_menu_manager: {
        info_menu: 'Le responsable pourra voir le temps et les dépenses de ces utilisateurs. {br} {learn_more}',
        info_menu_approval: 'Le responsable pourra approuver ou rejeter les {br} feuilles de temps et les dépenses de cet utilisateur. {br} {learn_more}',
        learn_more: 'En savoir plus'
      },
      info_menu_hourly_rate: {
        info_menu: 'Le tarif que vous facturez aux clients pour le temps de cette personne.{br} {learn_more}',
        learn_more: 'En savoir plus'
      },
      info_menu_hourly_cost: {
        info_menu: 'Coût interne engagé par cette personne pour votre entreprise.{br} {learn_more}',
        learn_more: 'En savoir plus'
      },
      you_are_about_to_change_element_to_user: 'Vous êtes sur le point de remplacer {element} par <b>utilisateur</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point de remplacer {element} par <b>{number} utilisateur</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_to_add_user_to_project: 'Vous êtes sur le point d\'ajouter un <b>utilisateur aux projets</b>.<br/> Cette action nécessite une confirmation | Vous êtes sur le point d\'ajouter <b>{number} utilisateurs aux projets</b>.<br/> Cette action nécessite une confirmation.',
      you_are_about_to_set_manager: 'Vous êtes sur le point de <b>désigner un responsable pour 1 utilisateur</b>. <br/>Cette action nécessite une confirmation | Vous êtes sur le point de <b>désigner un responsable pour {number} utilisateurs</b>. <br/>Cette action nécessite une confirmation',
      active_members: 'Membres actifs',
      deactivated_members: 'Membres désactivés',
      set_working_time: 'Définir les horaires de travail',
      set_working_time_to_all_users: 'Définir les horaires de travail pour tous les utilisateurs sélectionnés',
      set_hourly_rate_to_all_users: 'Définir le taux horaire pour tous les utilisateurs sélectionnés',
      set_hourly_cost_to_all_users: 'Définir le taux horaire pour tous les utilisateurs sélectionnés',
      set_manager_toltip: 'Assigner un manager à tous les utilisateurs sélectionnés'
    },
    userDialog: {
      add_new_user: 'Ajouter un nouvel utilisateur',
      last_seen: 'Dernière consultation',
      never_logged_in: 'Jamais connecté',
      is_part_of_group: 'Il fait partie du groupe',
      group_managers_cant_be_demoted: 'Les chefs de groupe ne peuvent pas être rétrogradés du poste de chef de projet si leur groupe est sur le projet',
      error_deactiving_user: 'Erreur lors de la désactivation de l\'utilisateur.',
      user_activated: 'Utilisateur activé.',
      error_activating_user: 'Erreur lors de l\'activation de l\'utilisateur.',
      error_deleting_user: 'Erreur lors de la suppression de l\'utilisateur.',
      changes_needs_saving: 'Les modifications doivent être enregistrées',
      activate: 'Activer',
      deleted_user: 'Utilisateur supprimé',
      edit_user: 'Modifier l\'utilisateur',
      select_manager: 'Sélectionner le gestionnaire pour l\'utilisateur'
    },
    userDeleteDialog: {
      all_entries: {
        all_entries_on_user: 'TOUS les enregistrements suivis par l\'utilisateur {0}.',
        going_to_be_deleted: 'sera éliminé'
      },
      all_data: {
        going_to_be_deleted: 'Toutes les données liées à l\'utilisateur seront immédiatement supprimées et {0} pourra être restauré.',
        not: 'Pas'
      },
      dont_want_to_lose_user: 'Si vous ne souhaitez pas perdre vos données, nous vous recommandons d\'archiver cet utilisateur. | Si vous ne souhaitez pas perdre vos données, nous vous recommandons plutôt d\'archiver ces utilisateurs.',
      user_deletion: 'Suppression d\'un utilisateur'
    },
    userActivationDialog: {
      you_are_about_to_activate: 'Vous êtes sur le point de devenir actif',
      you_are_about_to_deactivate: 'Vous êtes sur le point de désactiver',
      user_deactivation: 'Désactivation de l\'utilisateur',
      user_activation: 'Activation de l\'utilisateur',
      user_name: '{name} | {number} utilisateurs'
    },
    approvals: {
      title: 'Demandes d\'approbation',
      description: 'Votre équipe peut soumettre ses feuilles de temps et ses dépenses pour révision, que vous pouvez approuver ou rejeter.',
      approval_period: 'Période d\'approbation',
      workweek_begin: 'La semaine de travail commence le',
      edit_recurrence_start_tooltip: 'Modifier la date de récurrence de la période',
      manager_tooltip: 'Les gestionnaires peuvent approuver les dépenses et les feuilles de temps des utilisateurs qu\'ils gèrent.',
      minimum_role: 'Qui peut approuver les dépenses et les feuilles de temps',
      notification_role: 'Qui peut recevoir les notifications',
      recurrence_start: 'Début de la période de récurrence',
      recurrence_start_option: {
        previous_week: 'Semaine précédente',
        this_week: 'Cette semaine',
        next_week: 'La semaine prochaine',
        previous_month: 'Mois précédent',
        this_month: 'Ce mois-ci',
        next_month: 'Le mois prochain'
      },
      reminders: 'Définir des rappels',
      send_reminder_after_period_ends: 'Rappelez à tout le monde de soumettre leur feuille de temps et leurs dépenses {select} après la fin de la période d\'approbation à {time}.',
      auto_submit_after_period_ends: 'Soumettre automatiquement le relevé de temps et les dépenses de la période précédente {select} après la fin de la période d\'approbation.',
      auto_approve_after_period_ends: 'Approuver automatiquement les feuilles de temps et les dépenses soumises {select} après la fin de la période d\'approbation.',
      select_members: 'Sélectionnez les membres',
      no_pending_requests: 'Il n\'y a aucune demande d\'approbation en attente',
      no_unsubmitted_requests: 'Il n\'y a aucune demande d\'approbation non soumise',
      no_approved_requests: 'Il n\'y a aucune demande d\'approbation approuvée',
      send_email_reminder: 'Envoyer un rappel de demande d\'approbation',
      send_email_reminder_message: 'Vous êtes sur le point d\'envoyer un rappel par e-mail à 1 utilisateur | Vous êtes sur le point d\'envoyer un rappel par e-mail à {usersCount} utilisateurs',
      email_reminder_sent: 'Rappel par email envoyé',
      status: {
        pending_approval: 'En attente d\'approbation',
        approved: 'Approuvé',
        submitted: 'Soumis',
        unsubmitted: 'Non soumis',
        rejected: 'Rejeté',
        withdrawn: 'Retiré',
        action_required: 'Action requise'
      },
      action: {
        send_reminder: 'Envoyer un rappel par email',
        submit: 'Soumettre',
        submit_for_approval: 'Soumettre pour approbation',
        resubmit_for_approval: 'Soumettre à nouveau pour approbation',
        approve: 'Approuver',
        approve_all: 'Approuver toutes les demandes',
        reject: 'Rejeter',
        withdraw: 'Retirer'
      },
      tab: {
        pending: 'Dans l\'attente de',
        unsubmitted: 'Non soumis',
        approved: 'Approuvé'
      },
      timeline: {
        title_message: '{action} le {date} par {user_name}',
        view_full_history: 'Voir l\'historique complet',
        without_notes: 'sans notes'
      },
      user_name_timesheet: 'Feuille de temps de {user_name}',
      totalsWidget: {
        total_time: 'Temps total',
        approved: 'Approuvé',
        billable: 'Facturable',
        amount: 'Montant',
        expenses: 'Dépenses'
      },
      select_project: 'Sélectionner un projet',
      remove_project: 'Supprimer le projet'
    },
    approvalsDialog: {
      title: 'Confirmer la demande d\'approbation',
      reject_title: 'Rejeter la demande d\'approbation',
      withdraw_title: 'Retirer la demande d\'approbation',
      approve_title: 'Approuver les feuilles de temps et les dépenses',
      approve_all_title: 'Approuver tous les feuilles de temps et les dépenses',
      timesheet_submitted: 'Feuille de temps soumise pour approbation',
      timesheet_resubmitted: 'Fiche de temps resoumise pour approbation',
      timesheet_and_expenses_submitted: 'Feuille de temps et dépenses soumises pour approbation',
      timesheet_and_expenses_resubmitted: 'Feuille de temps et dépenses resoumise pour approbation',
      submit_title: 'Soumettre pour approbation',
      submit_description: 'Prêt à soumettre {0} pour approbation ?',
      approve_description: 'Une fois approuvé, le temps sera verrouillé et la feuille de temps sera déplacée dans l\'onglet Approuvé',
      time: 'Temps:',
      expenses: 'Dépenses :',
      add_note: 'Ajouter une note',
      request_updated: 'Demande d\'approbation mise à jour'
    },
    approvalTimelineDialog: {
      title: 'Historique des soumissions'
    },
    workingHours: {
      default: 'Heures de travail par défaut',
      reset_default: 'Restaurer les heures de travail du compte',
      weekly_total: 'Total hebdomadaire :'
    },
    workingHoursReminder: {
      reminders_additiona_settings: 'Rappels et paramètres supplémentaires',
      send_reminder_email_team: 'Envoyer un rappel par e-mail à toute personne ayant enregistré moins de',
      send_reminder_email_user: 'Envoyer un rappel par e-mail à cet utilisateur s\'il a suivi moins de',
      of_their: 'de leurs',
      capacity: 'capacité',
      capacity_on: 'capacité activée',
      capacity_on_month: 'capacité le dernier jour du mois',
      at: 'à',
      weekly_capacity: 'Ex. : Si un utilisateur a une capacité hebdomadaire de 40 heures et enregistre moins de 32 heures, il recevra un rappel par e-mail.',
      daily_capacity: 'Par exemple : Si un utilisateur a une capacité quotidienne de 8 heures et suit moins de 6,4 heures, il recevra un e-mail de rappel.',
      monthly_capacity: 'Par exemple : Si un utilisateur a une capacité mensuelle de 160 heures et suit moins de 128 heures, il recevra un e-mail de rappel à la fin du mois.',
      default_reminder_settings: 'Paramètres de rappel par défaut'
    },
    workspaceSettings: {
      general_settings: 'Paramètres généraux',
      security: 'Sécurité',
      features: 'Fonctionnalités',
      workspace_settings_saved: 'Paramètres de l\'espace de travail enregistrés',
      chose_image_for_workspace: {
        chose_the: 'Choisissez un {image} pour votre compte {el}.',
        image: 'Image'
      },
      this_image_is_visible_in: 'Cette image est visible dans la plupart des vues, en haut à gauche.',
      workspace_name: 'Nom de l\'espace de travail',
      chose_name_for_workspace: {
        chose_the: 'Choisissez le {0} qui apparaîtra pour ce compte.',
        name: 'nom'
      },
      oirganization_name: 'Nom de l\'organisation',
      currency: 'Devise',
      set_up_curency_and_billable_projects: {
        set_up: 'Configurez {currency_symbol} pour les rapports et les exportations de données dans votre {billable_projects}.',
        currency_symbol: 'Symbole monétaire',
        billable_projects: 'projets facturables'
      },
      show_working_time_dashboard: 'Afficher les heures de travail sur le tableau de bord',
      let_temmates_see_their_work: 'Permettez à vos coéquipiers de voir leurs heures de travail dans leur tableau de bord.',
      labour_cost: 'Coûts de main d\'œuvre',
      set_up_cost: {
        set_up_avarage_hourly_cost: "Configurez le co\xFBt horaire moyen de vos membres et voyez le co\xFBt de vos projets pour votre entreprise.\n        {br}\n        Vous pouvez \xE9galement d\xE9finir ceci pour les membres individuels de votre {team_members_view}.",
        team_members_view: 'Affichage des membres de l\'équipe'
      },
      register_time_for_user: 'Enregistrez le temps pour les autres utilisateurs',
      all_admins_on_this_workspace: {
        all_admins: 'Tous les administrateurs de cet espace de travail pourront {0} pour les autres utilisateurs.',
        can_create_entries: 'créer des enregistrements'
      },
      enabling_this_feature: {
        enabling_feature: 'En activant cette fonction {0} dans la liste des enregistrements.',
        add_user_option: 'ajoute une option utilisateur'
      },
      note_timers_cant_be_started_by_users: 'Remarque : Les minuteries ne peuvent pas être démarrées pour d\'autres utilisateurs.',
      // here
      working_hours: {
        title: 'Heures de travail',
        description: {
          set_default_working_days: 'Définissez la disponibilité et les jours de travail pour les utilisateurs dans votre espace de travail.',
          set_individual_working_days: 'Vous pouvez également le définir pour des membres individuels de votre {0}.',
          team_members_view: 'page des Utilisateurs'
        }
      },
      storage_capacity: {
        title: 'Capacité de stockage',
        description: {
          workspace_max_attachments_size: 'Chaque compte a un espace maximum disponible de {0} (licence payante) à utiliser pour les pièces jointes.',
          size_per_user: '{size_in_mb}Mo pour chaque utilisateur actif',
          workspace_max_attachments_size_example: 'Par exemple, si vous avez 3 licences payantes, l\'espace disponible est de {totalSize} Mo, {regardless} l\'utilisateur qui téléverse des fichiers.',
          regardless: 'indépendamment'
        },
        space_used_out_of_max: '{spaceUsed} utilisé sur {maxSize}'
      },
      export_workspace_data: 'Exporter les données de l\'espace de travail',
      export_data_will_generate_csv: 'L\'exportation de vos données générera un fichier CSV (que vous pourrez ouvrir avec Excel) contenant tous les enregistrements de votre compte.',
      this_will_be_sent_to_all_admins: 'Ce fichier sera envoyé à toutes les adresses e-mail des administrateurs de l’espace de travail en quelques minutes.',
      exporting: 'Exporter...',
      delete_workspace: 'Supprimer l\'espace de travail',
      once_you_confirm_will_be_deleted: 'Une fois confirmé, votre compte {el} sera supprimé.',
      evrything_will_be_deleted: 'Tous les enregistrements, minuteries, projets, clients, utilisateurs et toute autre donnée de ce compte seront supprimés.',
      this_is_not_possible_undo_action: 'Veuillez noter qu\'il n\'est PAS possible d\'annuler cette action.',
      export_data_before_workspace_deletion: 'Exportez les données avant de supprimer votre compte (un lien vers le fichier CSV, valable 48 heures, sera envoyé à tous les titulaires de compte)',
      type_delete: 'Tapez "{action}"',
      export_request_processed: 'Votre demande d\'exportation de données est en cours de traitement, vous (et les autres administrateurs de l\'espace de travail) recevrez un fichier zip dans votre boîte de réception dans quelques minutes.',
      account_scheduled_for_deletion: 'Votre compte devrait être supprimé.',
      error_on_deletion: 'Quelque chose s\'est mal passé.',
      authentication_methods: 'Méthodes d\'authentification',
      configure_the_allowed_authentication: 'Configurez les méthodes d\'authentification autorisées pour votre espace de travail.',
      require_password_or_google_microsoft: 'Exiger un mot de passe ou une connexion à Google/Microsoft',
      require_google_sigin: 'Exiger l\'accès à Google pour tout le monde',
      require_microsoft_sigin: 'Exiger l’accès à Microsoft pour tout le monde',
      configure_sso: 'Configurer l\'authentification unique (SAML2.0)',
      require_authentication_saml: 'Exiger une authentification via SAML2.0',
      saml_endpoint: 'URL du point de terminaison SAML (ACS)',
      timeneye_endpoint_expecting: 'Le point de terminaison Timeneye attend la charge utile d\'authentification d\'un fournisseur d\'identification SAML.',
      issuer_id: 'Identifiant de l\'émetteur',
      the_entity_id: 'L’ID d’entité du fournisseur d’identité.',
      login_url: 'URL de connexion (IDP)',
      the_url_used: 'URL utilisée pour accéder au fournisseur d\'identité SAML.',
      x509_certificate: 'Certificat X.509',
      the_signing_key: 'Clé de signature du fournisseur d\'identité SAML.',
      allow_username_password_auth: 'Autoriser la connexion via nom d\'utilisateur/mot de passe',
      turn_off_when_completed_testing_login: 'Désactivez cette option une fois que vous avez terminé le test d\'accès via votre fournisseur d\'identité.',
      download_sp_metadata: 'Télécharger les métadonnées SP',
      allow_third_party_apps: 'Autoriser les applications tierces',
      enable_disable_possibility_to_auth_third_party: 'Activez/désactivez la possibilité de mettre sur liste blanche les applications de développement tierces pour les utilisateurs de l\'espace de travail.',
      downloading_metadata: 'Téléchargement des métadonnées...',
      entries_lock: 'Blocage des enregistrements',
      select_date_to_lock_all_entries: 'Sélectionnez une date pour bloquer tous les enregistrements.',
      after_enabling_this: {
        after_enabling_all_entries: 'Après avoir activé ce paramètre, tous les enregistrements et minuteries en attente/actifs {0} périodiquement en fonction de la récurrence sélectionnée.',
        will_be_locked: 'sera automatiquement bloqué'
      },
      all_entry_will_still_be_visible: 'Tous les enregistrements bloqués seront toujours visibles, mais les utilisateurs ne pourront pas ajouter ou modifier des enregistrements avant la dernière date bloquée.',
      note_entry_lock_procesed_at_midnight: 'Remarque : Le blocage sera traité à minuit dans votre fuseau horaire.',
      type_valid_day: 'Veuillez entrer un numéro de jour valide',
      last_locked_date: 'Dernière date bloquée',
      expense_management: 'Gestion des dépenses',
      monitor_expenses: {
        monitor_in_timeneye: 'Suivez {0} dans Timeneye et attribuez-les à des projets, utilisateurs et clients spécifiques.',
        expeses: 'dépenses'
      },
      from_to_title: 'Vue chronologique',
      from_to_description: 'Affiche toutes les entrées de temps avec les heures de la journée clairement indiquées (par exemple de 09h00 à 10h00) dans le tableau de bord.',
      bill_clients: 'Facturez les clients avec précision et calculez la rentabilité du projet.',
      after_activating_a_new_section_will_appear: {
        after_activating: 'Après avoir activé cette fonctionnalité, une nouvelle section pour votre {expenses} apparaîtra dans le menu principal, ainsi qu\'une section {expense_categories} dans votre {workspace_settings}.',
        expenses: 'dépenses',
        expense_categories: 'Catégories de dépenses',
        workspace_settings: 'Paramètres de l\'espace de travail'
      },
      project_management: 'Gestion de projet',
      manage_and_track_time_on_task: {
        manage_and_track_time: 'Gérez et suivez le temps sur votre {0} directement dans Timeneye.',
        tasks: 'tâche'
      },
      after_activating_this: {
        after_activating_a_new_tab_will_appear: 'Après avoir activé cette fonctionnalité, un nouvel onglet {0} apparaîtra dans les détails du projet, après avoir activé les tâches pour ce projet à partir de la page d\'édition du projet.',
        tasks: 'tâche'
      },
      custom_report_logo: 'Logo personnalisé pour le rapport',
      chose_custom_image: {
        chose_custom: 'Choisissez un {0} personnalisé pour vos rapports.',
        image: 'Image'
      },
      this_image_will_be_shown: 'Cette image sera affichée dans le coin supérieur droit de vos rapports PDF.',
      remove_logo: 'Supprimer le logo',
      select_image_from_device: 'Déposez votre image ou cliquez ici pour la sélectionner depuis votre appareil',
      logo_should_be: 'Le rapport hauteur/largeur du logo doit être de 4:1 (par exemple 400 px x 100 px)',
      maximum_uploade_size: 'Taille maximale de téléchargement 2 M (jpg, jpeg, png, bmp)',
      drop_your_image_anywhere: 'Déposez votre image n\'importe où ou cliquez ici pour sélectionner depuis votre appareil',
      max_upload_size: 'Taille maximale de téléchargement 2 M (jpg, jpeg, png, bmp, svg, webp)',
      required_fields: 'Champ obligatoire',
      required_fields_description: 'Assurez-vous de définir certains champs comme requis pour tous les utilisateurs de votre espace de travail. Cela empêche les membres de l\'équipe d\'oublier les informations importantes et assure la cohérence de toutes les entrées de temps.',
      required_fields_entry_notes: 'L\'ajout de {notes} est requis lors de la création d\'une entrée de temps',
      required_fields_notes: 'Notes',
      required_fields_expense_project: 'La sélection d\'un {project} est requise lors de la création d\'une dépense',
      required_fields_project: 'Projet'
    }
  },
  layouts: {
    timesheet: 'Feuille de temps',
    trial_ended: 'TEST TERMINÉ',
    trial_left: 'TEST {el} restant | PREUVE {el} restante',
    subscription_expired: 'ABONNEMENT EXPIRÉ',
    grace_period: 'PÉRIODE DE GRÂCE : {number} jour restant | DÉLAI DE GRÂCE : il reste {number} jours',
    plan_billing: 'Planification et facturation',
    profile: 'Profil',
    product_updates: 'Mises à jour du produit',
    developers_portal: 'Portail des développeurs',
    logout_all_profiles: 'Se déconnecter de tous les profils',
    user_profile: 'Profil utilisateur',
    collapse_menu: 'Réduire le menu',
    expand_menu: 'Développez le menu'
  },
  pages: {
    billing: {
      current_plan: 'Abonnement actuel :',
      trial_flag: 'Essai',
      plan_pricing_details: "${monthlyPrice}/utilisateur/mois si pay\xE9 mensuellement, ou ${yearlyPrice}/ utilisateur/mois si pay\xE9 annuellement.",
      plan_expiration: 'Expiration :',
      trial_plan_expiration: 'Expiration de la période d\'essai :',
      microsoft_marketplace_description: 'Achetez votre abonnement sur le Microsoft marketplace',
      stripe_description: 'Utilisez les informations de votre carte de crédit pour procéder au paiement',
      plan_selection_action: 'Démarrez votre abonnement',
      manage_microsoft_licenses_action: 'Gérez votre licence sur le Marketplace Microsoft.',
      licenses_number: 'Numéro de licences : {licensesNumber}',
      days_left: {
        you_have_x_days: 'Il vous reste {number_days} sur votre {trial} plan',
        number_days: '{number} JOURS',
        free_trial: 'essai gratuit.'
      },
      number_active_licenses: '{number} licences actives',
      upgrade_plan: 'Plan de mise à niveau',
      manage_licenses: 'Gérer les licences',
      manage_subscription: 'Gérez votre abonnement',
      next_renewal: 'Prochaine reconduction : {date}',
      renewal_information: 'INFORMATIONS SUR LE RENOUVELLEMENT',
      no_active_subscription: 'Vous n\'avez aucun abonnement actif. Votre expiration est actuellement le {date}.',
      current_payment_is: 'Votre paiement {duration} actuel est {price} USD, avec un total de licences {limit_user}.',
      monthly_duration: 'mensuel',
      yearly_duration: 'annuel',
      billing_history: 'Historique de facturation',
      see_full_plan: 'Voir la comparaison complète des plans',
      invoices: 'Factures',
      billing_date: 'Date de facturation',
      please_suscribe: '{is_expired} Veuillez renouveler votre abonnement pour continuer à utiliser Timeneye',
      is_expired: 'Votre abonnement Timeneye a expiré.',
      start_subscription: 'Démarrez votre abonnement',
      licenses_updated: 'Le numéro de licence a été mis à jour',
      need_payment_confirmation: 'Vous devez confirmer le paiement pour continuer',
      confirm_payment: 'Confirmer le paiement'
    },
    automation_settings: 'Paramètres d\'automatisation',
    you_cant_access_your_biling_status: 'Vous ne pouvez pas accéder aux informations de facturation de Microsoft Teams.',
    click_here_to_change_settings: 'Cliquez ici pour modifier vos paramètres de facturation sur Timeneye.',
    developers_panel: 'Panneau de développement',
    create_and_manage_your_applications: 'Créez et gérez vos applications pour donner à vos utilisateurs accès aux API Timeneye.',
    how_to_get_started: 'Comment commencer',
    applications: 'Applications',
    no_apps_created: 'Aucune application créée',
    create_new_app: 'Créer une nouvelle application',
    delete_app: 'Supprimer l\'application',
    delete_app_confirmation: 'Êtes-vous sûr de vouloir supprimer l\'application {app_name} ?',
    app_deleted: 'Application supprimée.',
    email_verification: 'Vérifier l\'e-mail',
    enter_code_you_recived: 'Entrez le code que vous avez reçu par e-mail pour vérifier votre adresse e-mail.',
    verify_email: 'Vérifier l\'e-mail',
    verifying_email: 'Vérifier l\'e-mail...',
    go_back_to_login: 'Retour au formulaire de connexion',
    invalid_recaptcha: 'Récapitulatif invalide',
    the_code_not_valid: 'Le code n\'est pas valide',
    error_message: {
      message: 'Désolé, il n\'y a rien ici...{0}',
      error: '(404)'
    },
    go_back: 'Retourner',
    saml_sign_on: 'Authentification unique SAML',
    use_email_that_matches_sso: 'Utilisez l\'e-mail qui correspond à vos identifiants SSO.',
    forgot_your_password: 'Avez-vous oublié votre mot de passe ?',
    sign_with_microsoft: 'Connectez-vous avec Microsoft',
    sign_with_google: 'Connectez-vous avec Google',
    sign_with_saml: 'Connectez-vous avec SAML SSO',
    other_ways_to_sign_in: 'Plus de façons de se connecter',
    dont_have_workspace: 'Vous n\'avez pas de compte ?',
    error_during_authentication: 'Un problème est survenu lors de l\'authentification',
    fail_log_in: 'Impossible de se connecter. Votre email et/ou votre mot de passe sont peut-être manquants.',
    confirm_password: 'Confirmez votre mot de passe',
    your_password_has_been_chenged: 'Votre mot de passe a été modifié. {br}Vous pouvez désormais vous connecter avec vos nouveaux identifiants.',
    enter_your_email_for_reset: 'Entrez votre adresse e-mail et nous vous enverrons des instructions pour réinitialiser votre mot de passe.',
    type_your_email: 'Tapez votre adresse e-mail',
    send_reset_instructions: 'Envoyez-moi des instructions de récupération',
    sending_reset_instructions: 'Envoi des instructions de récupération...',
    you_should_recive_an_email: 'Vous devriez recevoir un e-mail avec le lien de restauration dans quelques secondes.',
    if_dont_recive_it: 'Si vous ne recevez pas d\'e-mail de notre part dans quelques minutes, assurez-vous de vérifier votre filtre anti-spam.',
    trusted_by: 'Approuvé par plus de 800 entreprises dans 50 pays',
    sign_up_for_free: 'Inscrivez-vous gratuitement',
    join_timeneye_for_free: 'Rejoignez Timeneye gratuitement.',
    no_credit_card_needed: 'Aucune carte de crédit n\'est nécessaire.',
    by_signing_up_i_agree: {
      by_signing: 'En m\'inscrivant, j\'accepte nos {privacy_policy} et {terms_of_service}',
      privacy_policy: 'politique de confidentialité',
      terms_of_service: 'Conditions d\'utilisation'
    },
    continue_sign_up: 'Continuez l\'inscription ici',
    open_with_teams: 'Ouvrir dans Microsoft Teams',
    sign_up_with_microsoft: 'Inscrivez-vous avec Microsoft',
    sign_up_with_email: 'Inscrivez-vous avec votre email',
    min_length_name: 'Votre nom complet doit contenir au moins 3 caractères',
    email_required: 'L\'e-mail est requis',
    work_email: 'E-mail professionnel',
    or_sign_up_with: 'Ou inscrivez-vous avec',
    aleardy_have_an_account_sign_in: {
      aleardy_have_an_account: 'Vous avez déjà un compte ?{0}',
      sig_in: 'Se connecter'
    },
    track_your_projects_in_timeneye: 'Suivez vos projets dans Timeneye et augmentez votre productivité',
    manage_projects: 'Gérer des projets :',
    track_time_on_project: 'Suivez la durée du cycle de vie de votre projet, gardez un œil sur les budgets et restez en contact avec votre équipe.',
    report_analyze: 'Rapporter et analyser :',
    create_visual_report: 'créez un rapport visuel pour analyser la productivité et faire de meilleures estimations pour l\'avenir.',
    accurate_billing: 'Facturation précise :',
    deliver_billable_minute: 'livrez à temps et capturez chaque minute facturable travaillée par toute votre équipe.',
    subscription_expired: 'Abonnement expiré',
    your_timeneye_subscription_expired: 'Votre abonnement Timeneye a expiré.',
    contact_your_workspace: {
      workspace_owners: 'propriétaires de comptes',
      contact_your_workspace_owner_expired: 'Contactez votre {workspace_owners} pour renouveler votre abonnement {br} et continuer à utiliser Timeneye.',
      contact_your_workspace_owner_trial_ended: 'Contactez votre {workspace_owners} pour passer à un forfait payant {br} et continuer à utiliser Timeneye.',
      contact_your_workspace_owner_unauthorized: 'Contactez votre {workspace_owners} pour continuer à utiliser Timeneye.'
    },
    trial_ended: 'Le processus est terminé',
    your_timeneye_trial_expired: 'Votre essai Timeneye est terminé.',
    unauthorized: 'Non autorisé',
    your_timeneye_user_has_been_disabled: 'Votre utilisateur Timeneye a été désactivé par un administrateur.',
    go_to_login_page: 'Accédez à la page de connexion',
    new_password: 'Nouveau mot de passe',
    or: 'OU',
    // between 2 buttons
    authenticating: 'Authentification de {integrationName}...'
  },
  mixins: {
    your_calendar_has_been_updated: 'Votre calendrier a été mis à jour',
    failed_to_link_integration: 'Impossible de connecter l\'intégration.',
    failed_to_get_integration: 'Impossible d\'obtenir l\'intégration.',
    error_during_authentication: 'Un problème est survenu lors de l\'authentification',
    billable_time: 'Temps facturable',
    not_billable_time: 'Temps non facturable',
    billed_money: 'Montant facturé',
    billable_money: 'Montant facturable',
    total_money: 'Montant total',
    total_cost: 'Coût total',
    billed_cost: 'Coût facturé',
    unbilled_cost: 'Coût non facturé',
    total_profit: 'Bénéfice total',
    total_unbilled: 'Total non facturé',
    billed_profit: 'Bénéfice facturé',
    unbilled_profit: 'Bénéfice non facturé',
    favorite: 'Préféré',
    column_disable_if: 'Cette colonne est désactivée si plusieurs projets sont sélectionnés ou si le projet n\'a pas de budget.',
    invitation_status: 'Statut de l\'invitation',
    labor_cost: 'Coûts de main d\'œuvre',
    locked_status: 'État bloqué',
    locked: 'Bloqué',
    billing_status: 'Statut de facturation',
    total_expenses: 'Dépenses totales',
    unit_price: 'Prix ​​unitaire',
    task_list: 'Liste des tâches',
    source: 'Source',
    progress: 'Progrès',
    todo: 'Tâche',
    billed_fixed_fee: 'Honoraire forfaitaire facturé',
    unbilled_fixed_fee: 'Tarif fixe non facturé',
    billed_money_info: 'Argent facturé = main d\'œuvre facturée + dépenses facturées + forfait facturé',
    total_cost_info: 'Coûts totaux = coûts de main-d\'œuvre + dépenses totales',
    billed_labor: 'Main d\'œuvre facturée',
    unbilled_labor: 'Main d\'œuvre non facturée'
  },
  notificationPanel: {
    general: 'Général',
    announcements: 'Publicités'
  },
  app: {
    session_expired: 'Votre session a expiré. Veuillez vous reconnecter pour continuer.',
    go_to_project: 'Aller au projet',
    go_to_integration: 'Aller à l\'intégration',
    sidebar: {
      show: 'Afficher la barre latérale',
      collapse: 'Réduire la barre latérale',
      unpin: 'Ouvrir',
      pin: 'Bloc',
      register_time: 'Enregistrer',
      dashboard: 'Tableau de bord',
      dashboard_short: 'Tableau',
      expenses: 'Dépenses',
      entries_log: 'Liste d\'enregistrement',
      entries_log_short: 'Enregistrements',
      team: 'Équipe',
      projects: 'Projets',
      clients: 'Clientèle',
      reports: 'Rapports',
      tasks: 'Tâches',
      timesheet: 'Feuille de temps',
      approvals: 'Approbations',
      integrations: 'Intégrations',
      data_management: 'Gestion des données',
      data_management_short: 'Gestion',
      tags: 'Étiquettes',
      phase_categories: 'Catégories de phases',
      expense_categories: 'Catégories de dépenses',
      import_data: 'Importer des données',
      settings: 'Paramètres',
      subscription: 'Abonnement',
      notifications: 'Notifications',
      support: 'Soutien',
      help_center: 'Centre d\'aide',
      tutorial_videos: 'Tutoriels vidéo',
      product_updates: 'Mises à jour du produit',
      feature_request: 'Demander une fonctionnalité',
      developers_portal: 'Portail des développeurs',
      contact_support: 'Contacter l\'assistance',
      subscription_expired: 'ABONNEMENT EXPIRÉ',
      x_day_left: '{number} jour restant | Il reste {number} jours',
      personal_settings: 'Paramètres personnels',
      switch_account: 'Changer d\'utilisateur',
      switch_bach_to_old_version: 'Revenir à l\'ancienne version',
      new_version_avaiable: 'Nouvelle version disponible !',
      click_here_to_update: 'Cliquez pour mettre à jour',
      logout: 'Quitter | Se déconnecter de tous les profils'
    }
  },
  boot: {
    can_only_see_track_edit: 'Il peut uniquement voir, suivre et modifier ses propres minuteries et enregistrements.',
    can_see_track_edit: 'Peut voir, suivre et modifier les minuteries et les enregistrements de tous les membres de l\'équipe',
    it_is_admin: 'Il est administrateur mais peut gérer les détails de facturation et supprimer l\'espace de travail'
  }
};